<template>
  <v-container no-gutters class="ma-0 px-0" :style="`min-width:100vw; min-height:100vh; background-position:top center; background-size:initial; background-repeat: repeat; background-image:url('${require('../../assets/dark parchment background.jpg')};`">
    <v-toolbar class="background_bar" absolute height="64px" style="max-height:104px; z-index:99; position:fixed; width:100%;">
        <v-row style="width:100%; justify-content: center; align-items: center;">
            <v-spacer/>
            <v-text-field hide-details v-model="character.characterName" outlined dense style="background-color:antiquewhite; max-width:300px; text-align-last:center; font-size:24px; font-weight:bold; color:black; margin-left:75px"></v-text-field>
            <v-menu offset-y nudge-left="60">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="color:gray;"
                    >
                    <v-icon style="font-size:32px;">settings</v-icon>
                    </v-btn>
                </template>
                
                <v-list>
                    <v-list-item @click="savingSettingsDialog = true">
                        <v-list-item-title>Save/Load Settings</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="hotkeysDialog = true">
                        <v-list-item-title>Hotkeys</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="resetDay()">
                        <v-list-item-title>Reset Day</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item @click="rulesDialog = true"> this is spare text for nothing!
                        <v-list-item-title>Maneuver Rules</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="disciplineHelpDoc = true">
                        <v-list-item-title>Discipline Rules</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="websiteRulesDoc = true">
                        <v-list-item-title>Website Guide</v-list-item-title>
                    </v-list-item> -->
                    <!-- <v-list-item @click="migrateCharacters()">
                        <v-list-item-title>Migrate Characters</v-list-item-title>
                    </v-list-item> -->
                </v-list>
            </v-menu>
            <v-spacer/>
            <v-menu offset-y nudge-left="60">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="color:gray;"
                    >
                    <v-icon style="font-size:32px;">menu</v-icon>
                    </v-btn>
                </template>
                
                <v-list>
                    <v-list-item @click="quickDetails = !quickDetails">
                        <v-list-item-title>Quick Details</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="stickyTracker = !stickyTracker">
                        <v-list-item-title>Point Tracker</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="stickyNotes = !stickyNotes">
                        <v-list-item-title>Notes</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="stickyBuffs = !stickyBuffs">
                        <v-list-item-title>Buffs</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-row>
        
    </v-toolbar>
    <v-toolbar absolute height="64px" style="max-height:104px; z-index:99; position:fixed; min-width:101%; top:56px; background-color:transparent;" class="pa-0 ma-0" flat>
        <v-row style="justify-content: center; align-items: center;">
            <v-tabs v-model="tab" background-color="#654321" dark align-tabs="center" fixed-tabs>
                <v-tab>
                    Character Sheet
                </v-tab>
                <v-tab>
                    Maneuver Tracker
                </v-tab>
                <v-tab>
                    Spell Tracker
                </v-tab>
                <!-- <v-tab>
                    Psyche
                </v-tab> -->
            </v-tabs>
        </v-row>
    </v-toolbar>
    
    

    <div>
    

    <v-tabs-items v-model="tab" style="background-color:transparent; width:100%; padding-left:16px; margin-top:38px;">

        <v-tab-item eager>
            <character-sheet ref="characterSheet" :character="character" :locked="characterLocked" :applying-server-state="isApplyingServerState"></character-sheet>
        </v-tab-item>

        <v-tab-item eager>
            <maneuver-tracker ref="maneuverTracker" :character="character"></maneuver-tracker>
        </v-tab-item>

        <v-tab-item eager>
            <spell-tracker ref="spellTracker" :character="character"></spell-tracker>
        </v-tab-item>

        <v-tab-item>
            <psychic-duels :character="character"></psychic-duels>
        </v-tab-item>

    </v-tabs-items>

    <div v-if="stickyTracker" :style="`position:fixed; z-index:101; min-width:300px; max-width: 400px; left: ${trackerPosition.x}px; top: ${trackerPosition.y}px; transition: ${isDragging ? '0.05s' : '0s'} ease;`" class="draggable-notes">
        <v-card style="width:100%; background-color:#DEB887;" elevation="4">
            <v-card-title style="cursor:move;" @mousedown="startDrag" id="stickyTracker" class="headline brown darken-4">
                <div style="color:antiquewhite; pointer-events: none;" >Point Trackers</div>
                <v-spacer/>
                <v-icon style="font-size:32px; color:antiquewhite" @click="trackerDoc = true">settings</v-icon>
                <v-icon class="no-background" @click="stickyTracker = false" style="margin-right:4px; color:antiquewhite; background-color:transparent!important">subdirectory_arrow_left</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row v-for="tracker in pointTrackers" :key="tracker.id" style="align-items:center; margin-top:8px;">
                    <v-row style="border-bottom-width: 2px; border-bottom-style: solid; border-bottom-color:grey; margin-left:8px; margin-right:8px; margin-bottom:8px;">
                        <v-col style="text-align:left; margin-top:8px;">
                            <h3 style="font-size:20px; font-weight:bold; color:black">{{tracker.name}}</h3>
                        </v-col>
                        <v-col style="display: flex; justify-content: right; padding-right:20px;">
                            <v-icon @click="tracker.value++" class="mt-2">add</v-icon>
                            <v-text-field v-model="tracker.value" style="font-size:24px; max-width:50px; text-align-last:center;" hide-details="true" dense @focus="tempTracker = tracker.value; tracker.value = ''" @keyup.enter="doTrackerMath(tracker)" @change="checkChange(tracker)"></v-text-field><span style="white-space:nowrap;">/ {{ tracker.max }}</span>
                            <v-icon @click="tracker.value--" class="mt-2">remove</v-icon>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row v-if="pointTrackers.length > 0" style="justify-content:center; margin-top:36px;margin-bottom:0px;">
                    <v-btn small @click="resetTrackers()">Reset All</v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </div>

    <div v-if="stickyNotes" :style="`position:fixed; z-index:101; left: ${notesPosition.x}px; top: ${notesPosition.y}px; transition: ${isDragging ? '0.05s' : '0s'} ease;`" class="draggable-notes">
        <v-card v-if="stickyNotes" style="background-color:#DEB887;" elevation="4">
            <v-card-title style="cursor:move;" @mousedown="startDrag" id="stickyNotes" class="headline brown darken-4"><div style="color:antiquewhite; pointer-events: none;">Notes</div><v-spacer/><v-icon class="no-background" @click="stickyNotes = false" style="margin-bottom:8px; color:antiquewhite">subdirectory_arrow_left</v-icon></v-card-title>
            <textarea ref="notesTextarea" v-model="character.stickyWindows.notes" :style="`background-color:antiquewhite; resize:both; width:${character.stickyWindows.notesWidth || 250}px; height:${character.stickyWindows.notesHeight || 340}px; min-width:200px; min-height:100px; margin-bottom: -6px !important; border:none;outline:none; padding-left:4px`" class="ma-0 light">
          </textarea>
        </v-card>
    </div>

    <div v-if="quickDetails" :style="`position:fixed; z-index:101; min-width:300px; max-width: 350px; left: ${quickDetailsPosition.x}px; top: ${quickDetailsPosition.y}px; transition: ${isDragging ? '0.05s' : '0s'} ease;`" class="draggable-notes">
        <v-card v-if="quickDetails" style="background-color:#DEB887;" elevation="4">
          <v-card-title style="cursor:move;" @mousedown="startDrag" id="quickDetails" class="headline brown darken-4"><div style="color:antiquewhite; pointer-events: none;">Quick Details</div><v-spacer/><v-icon class="no-background" @click="quickDetails = false" style="margin-bottom:8px; color:antiquewhite">subdirectory_arrow_left</v-icon></v-card-title>
          <v-card-text class="pa-2">
            <!-- Ability Scores -->
            <div class="mb-2">
              <div class="text-subtitle-1 font-weight-bold" style="margin-bottom:2px;line-height:1.3;">Ability Scores</div>
              <v-row dense>
                <v-col v-for="(ability, key) in character.characterData.abilities" :key="key" cols="2" class="pa-0 ma-0" no-gutters>
                  <v-tooltip bottom :open-delay="300">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="font-size:12px; cursor:pointer; text-align:center;">
                        <span style="font-weight:bold;">{{ getAbilityShortName(key) }}:</span>
                        <span style="margin-left:4px;">{{ formatAbilityModifier(ability.modifiedModifier) }}</span>
                      </div>
                    </template>
                    <div style="font-size:12px; line-height:1.6;">
                      <div><strong>Score:</strong> {{ ability.score }}</div>
                      <div><strong>Bonus:</strong> {{ ability.bonus || 0 }}</div>
                      <div><strong>Damage:</strong> {{ ability.damage || 0 }}</div>
                      <div><strong>Drain:</strong> {{ ability.drain || 0 }}</div>
                      <div><strong>Burn:</strong> {{ ability.burn || 0 }}</div>
                      <div><strong>Wither:</strong> {{ ability.wither || 0 }}</div>
                      <div><strong>Permanent:</strong> {{ ability.permanent || 0 }}</div>
                      <div style="margin-top:4px; border-top:1px solid rgba(255,255,255,0.3); padding-top:4px;"><strong>Modified:</strong> {{ ability.modifiedScore }} ({{ formatAbilityModifier(ability.modifiedModifier) }})</div>
                    </div>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>

            <!-- Health Section -->
            <div class="mb-2">
              <div class="text-subtitle-1 font-weight-bold mb-2">Health</div>
              <v-row dense>
                <v-col cols="4">
                  <v-text-field v-model="character.characterData.defense.hp.temp" label="Temp HP" hide-details dense @focus="tempQuickValue = character.characterData.defense.hp.temp; character.characterData.defense.hp.temp = ''" @keyup.enter="doQuickMath('temp')" @change="checkQuickChange('temp')" style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="character.characterData.defense.hp.nonLethal" label="Non-Lethal" hide-details dense @focus="tempQuickValue = character.characterData.defense.hp.nonLethal; character.characterData.defense.hp.nonLethal = ''" @keyup.enter="doQuickMath('nonLethal')" @change="checkQuickChange('nonLethal')" style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <div style="position: relative;">
                    <v-text-field v-model="character.characterData.defense.hp.delayed" label="Delayed" hide-details dense @focus="tempQuickValue = character.characterData.defense.hp.delayed; character.characterData.defense.hp.delayed = ''" @keyup.enter="doQuickMath('delayed')" @change="checkQuickChange('delayed')" style="font-size:14px;"></v-text-field>
                    <span v-if="character.characterData.defense.hp.delayedMax > 0" 
                          style="position: absolute; top: -8px; right: 8px; font-size: 14px; color: #666;">
                      /{{ character.characterData.defense.hp.delayedMax }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Defense Section -->
            <div class="mb-2">
              <div class="text-subtitle-1 font-weight-bold mb-2">Defense</div>
              <v-row dense>
                <v-col cols="3">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.acTotal : character.characterData.defense.ac.total" label="AC" hide-details dense readonly style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.acTouch : character.characterData.defense.ac.touch" label="Touch" hide-details dense readonly style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.acFlatFooted : character.characterData.defense.ac.flatFooted" label="Flat" hide-details dense readonly style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.cmdTotal : character.characterData.defense.cmd.total" label="CMD" hide-details dense readonly style="font-size:14px;"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3 mt-2">
                <v-col cols="12">
                  <v-text-field v-model="quickDetailsData.acModifiers" label="AC Modifiers" hide-details dense @input="updateDefenseFromModifiers" style="font-size:14px;"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.saveTotals.fortitude : character.characterData.defense.saves.fortitude.total" label="Fort" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.saveTotals.reflex : character.characterData.defense.saves.reflex.total" label="Ref" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.saveTotals.will : character.characterData.defense.saves.will.total" label="Will" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Offense Section -->
            
            <div class="mb-2">
              <div class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center">
                Offense
                <div style="position: relative; display: inline-block;">
                  <v-icon 
                    small 
                    class="ml-2" 
                    style="cursor: pointer; font-size: 16px;"
                    @click="openDiceSettings"
                    title="Open dice settings"
                  >
                    settings
                  </v-icon>
                  <span
                      v-if="getTotalDiceSettingsCount() > 0"
                      style="position: absolute; top: -6px; right: -6px; color: cyan; font-size: 12px; font-weight: bold; line-height: 1; background-color:rgba(0, 0, 0, 0.9); border-radius: 50%; padding: 2px; width:16px; text-align: center;"
                  >
                      {{ getTotalDiceSettingsCount() }}
                  </span>
                </div>
              </div>
              <v-row dense>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.getTotalAttackBonus() : character.characterData.offense.attackBonus.total" label="Atk" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.getTotalCMB() : character.characterData.offense.cmb.total" label="CMB" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field :value="$refs.characterSheet ? $refs.characterSheet.getTotalCMB2() : character.characterData.offense.cmb2.total" label="CMB 2" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="mt-2">
                <v-col cols="6">
                  <v-text-field v-model="character.characterData.offense.globalAttackModifier" label="Global Attack" hide-details dense style="font-size:14px;" placeholder="+2 bless"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="character.characterData.offense.globalDamageModifier" label="Global Damage" hide-details dense style="font-size:14px;" placeholder="+1d6 fire"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                    <div v-if="getSelectedDamageCalculations().length > 0">
                        <div v-for="(attack, index) in getSelectedDamageCalculations()" :key="index" class="mb-2">
                        <!-- Attack Display Row -->
                        <div style="margin-bottom: 2px;">
                            <!-- Weapon Name Row (Expanded) -->
                            <v-row v-if="!attack.collapsed" dense style="margin-bottom: 0px; min-height: 16px;">
                                <v-col cols="10" style="padding: 0 8px;">
                                    <span class="text-caption" style="font-size:11px; line-height: 1;">
                                    <v-icon 
                                    x-small 
                                    class="mr-1" 
                                    style="cursor: pointer; font-size: 14px;"
                                    @click="handleAttackDiceClick($event, attack)"
                                    title="Click to copy; Shift+click to roll in Roll20"
                                    >
                                    mdi-dice-d20
                                    </v-icon><strong>{{ attack.weapon }}:</strong>
                                    </span>
                                </v-col>
                                <v-col cols="2" style="padding: 0 4px; display: flex; justify-content: flex-end; align-items: center;">
                                    <v-icon 
                                    x-small 
                                    style="cursor: pointer; font-size: 12px;"
                                    @click="toggleAttackCollapse(index)"
                                    title="Toggle attack details"
                                    >
                                    {{ attack.collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                    </v-icon>
                                </v-col>
                            </v-row>
                            
                            <!-- Collapsed Preview (Single Line) -->
                            <v-row v-if="attack.collapsed" dense style="margin-bottom: 0px; min-height: 16px;">
                                <v-col cols="10" style="padding: 0 8px;">
                                    <span class="text-caption" style="font-size:11px; line-height: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; max-width: 100%;">
                                    <v-icon 
                                    x-small 
                                    class="mr-1" 
                                    style="cursor: pointer; font-size: 14px;"
                                    @click="handleAttackDiceClick($event, attack)"
                                    title="Click to copy; Shift+click to roll in Roll20"
                                    >
                                    mdi-dice-d20
                                    </v-icon><strong>{{ attack.weapon }}:</strong> {{ attack.combinedAttackBonus }} | {{ attack.combinedDamageText }}/{{ attack.criticalRange }}{{ attack.criticalMult }}
                                    </span>
                                </v-col>
                                <v-col cols="2" style="padding: 0 4px; display: flex; justify-content: flex-end; align-items: center;">
                                    <v-icon 
                                    x-small 
                                    style="cursor: pointer; font-size: 12px;"
                                    @click="toggleAttackCollapse(index)"
                                    title="Toggle attack details"
                                    >
                                    {{ attack.collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                    </v-icon>
                                </v-col>
                            </v-row>
                            
                            <!-- Attack Details (Collapsible) -->
                            <div v-if="!attack.collapsed">
                                <!-- Attack Line with Temp Attack Field -->
                                <v-row dense style="margin-bottom: 0px; min-height: 16px; align-items: end; margin-top: -16px;">
                                    <v-col cols="8" style="padding: 0 8px; display: flex; align-items: center;">
                                        <span class="text-caption" style="font-size:11px; line-height: 1;">
                                        <b>Atk:</b> {{ attack.combinedAttackBonus }}
                                        </span>
                                    </v-col>
                                    <v-col cols="4" style="padding: 0 4px; display: flex; align-items: center;">
                                        <v-text-field
                                            :value="attack.tempAttackModifiers"
                                            @input="updateTempAttackModifiers(index, $event)"
                                            hide-details
                                            dense
                                            style="font-size:9px;"
                                            class="text-caption"
                                            placeholder="Temp Attack"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                
                                <!-- Damage Line with Temp Damage Field -->
                                <v-row dense style="margin-bottom: 0px; margin-top:-8px; align-items: end;">
                                    <v-col cols="8" style="padding: 0 8px; display: flex; align-items: center;">
                                        <span class="text-caption" style="font-size:11px; line-height: 1;">
                                        <b>Dmg:</b> ({{ attack.combinedDamageText }}/{{ attack.criticalRange }}{{ attack.criticalMult }})
                                        </span>
                                    </v-col>
                                    <v-col cols="4" style="padding: 0 4px; display: flex; align-items: center">
                                        <v-text-field
                                            :value="attack.tempDamageModifiers"
                                            @input="updateTempDamageModifiers(index, $event)"
                                            hide-details
                                            dense
                                            style="font-size:9px;"
                                            class="text-caption"
                                            placeholder="Temp Damage"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                
                                <!-- Additional Damage Types -->
                                <v-row v-if="attack.nonMultipliedDamage || attack.precision" dense style="min-height: 14px;">
                                    <v-col cols="12" style="padding: 0 32px;">
                                        <span v-if="attack.nonMultipliedDamage" class="text-caption" style="font-size:10px; line-height: 1; margin-left: 20px;">
                                        {{ attack.nonMultipliedDamage.startsWith('+') ? attack.nonMultipliedDamage : '+' + attack.nonMultipliedDamage }}
                                        </span>
                                        <span v-if="attack.precision" class="text-caption" style="font-size:10px; line-height: 1;">
                                        {{ attack.precision.startsWith('+') ? attack.precision : '+' + attack.precision }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        </div>
                    </div>
                    <v-text-field v-else v-model="quickDetailsData.damage" label="Damage" hide-details dense style="font-size:14px;"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <div v-if="character.characterData.skills.background.concat(character.characterData.skills.adventuring).filter(skill => skill.inQN).length > 0">
                    <v-divider class="my-2"></v-divider>
                    <div class="text-subtitle-2 mb-0">Skills:</div>
                    <v-row dense no-gutters v-for="skill in character.characterData.skills.background.concat(character.characterData.skills.adventuring).filter(skill => skill.inQN)" :key="skill.name + (skill.specific || '')" class="mb-0" style="align-items: baseline; height: 24px;">
                        <v-col cols="4" class="py-0">
                          <span style="text-body-2">
                            {{ skill.name }}{{ skill.specific ? ' (' + skill.specific + ')' : '' }}:
                            <v-tooltip v-if="skill.notes && skill.notes.length > 1" bottom :open-delay="1000">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" size="12" color="#666" style="vertical-align: super; cursor: help;">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ skill.notes }}</span>
                            </v-tooltip>
                          </span>
                        </v-col>
                      <v-col cols="2" class="py-0">
                        <span class="text-body-1">{{ utilities.calculateSkillsTotal(skill, characterData, pointTrackers) >= 0 ? '+' : '' }}{{ utilities.calculateSkillsTotal(skill, characterData, pointTrackers) }}</span>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="skill.temp"
                          type="text"
                          hide-details
                          dense
                          placeholder="Temp"
                          style="font-size: 12px;"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
    </div>


    <div v-if="stickyBuffs" :style="`position:fixed; z-index:101; min-width:300px; max-width: 400px; left: ${buffsPosition.x}px; top: ${buffsPosition.y}px; transition: ${isDragging ? '0.05s' : '0s'} ease;`" class="draggable-notes">
        <v-card style="width:100%; background-color:#DEB887;" elevation="4">
            <v-card-title style="cursor:move;" @mousedown="startDrag" id="stickyBuffs" class="headline brown darken-4">
                <div style="color:antiquewhite; pointer-events: none;">Buffs</div>
                <v-spacer/>
                <v-icon style="font-size:32px; color:antiquewhite" @click="buffsDoc = true">settings</v-icon>
                <v-icon class="no-background" @click="stickyBuffs = false" style="margin-right:4px; color:antiquewhite; background-color:transparent!important">subdirectory_arrow_left</v-icon>
            </v-card-title>
            <v-card-text>
                <v-tabs v-model="buffPanelTab" height="26" background-color="transparent" color="#3e2723" show-arrows class="buff-panel-tabs" style="margin-bottom:8px;">
                    <v-tab
                        v-for="tab in buffPanelTabIds"
                        :key="tab"
                        style="font-size:12px; min-width:0; text-transform:none; letter-spacing:normal;"
                    >{{ buffPanelTabLabel(tab) }}</v-tab>
                </v-tabs>
                <v-row no-gutters style="justify-content:center; margin-bottom:8px;">
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(1)">-1 Round</v-btn>
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(10)">-1 Min</v-btn>
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(600)">-1 Hour</v-btn>
                </v-row>
                <v-row no-gutters style="justify-content:center; margin-bottom:8px;">
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(-1)">+1 Round</v-btn>
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(-10)">+1 Min</v-btn>
                    <v-btn x-small class="mx-1" @click="advanceBuffTime(-600)">+1 Hour</v-btn>
                </v-row>
                <div v-show="!isCommonStatusBuffPanel">
                    <div v-if="visiblePanelBuffs.length === 0" style="color:black; text-align:center; margin-top:12px;">
                        No buffs on this tab. Click the gear to add some.
                    </div>
                    <v-tooltip v-for="buff in visiblePanelBuffs" :key="buff.id" bottom :open-delay="300">
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on" @contextmenu.prevent.stop="openBuffTimeMenu($event, { kind: 'buff', id: buff.id })" style="border-bottom: 1px solid grey; padding: 2px 4px; display:flex; align-items:center;" title="Right-click to adjust time">
                                <v-checkbox v-model="buff.active" :label="buff.name || 'Unnamed Buff'" hide-details dense class="mt-0 pt-0" style="flex:1;" @change="onBuffToggled(buff)"></v-checkbox>
                                <span
                                    :style="`font-size:12px; white-space:nowrap; cursor:context-menu; padding-left:8px; color:${buff.remainingRounds == null ? '#8d6e63' : buff.remainingRounds > 0 ? 'black' : '#b71c1c'};`"
                                >{{ buff.remainingRounds == null ? '—' : formatBuffDuration(buff.remainingRounds) }}</span>
                            </div>
                        </template>
                        <div style="font-size:12px; line-height:1.6;">
                            <div v-for="effect in buff.effects" :key="effect.id">{{ describeBuffEffect(effect) }}</div>
                        </div>
                    </v-tooltip>
                </div>
                <div v-show="isCommonStatusBuffPanel">
                    <v-tooltip v-for="status in commonStatuses" :key="status.id" bottom :open-delay="300">
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on" @contextmenu.prevent.stop="openBuffTimeMenu($event, { kind: 'status', id: status.id })" style="border-bottom: 1px solid grey; padding: 2px 4px; display:flex; align-items:center;" title="Right-click to adjust time">
                                <v-checkbox :input-value="getStatusState(status.id).active" :label="status.name" hide-details dense class="mt-0 pt-0" style="flex:1;" @change="onStatusToggled(status, $event)"></v-checkbox>
                                <span
                                    :style="`font-size:12px; white-space:nowrap; cursor:context-menu; padding-left:8px; color:${getStatusState(status.id).remainingRounds == null ? '#8d6e63' : getStatusState(status.id).remainingRounds > 0 ? 'black' : '#b71c1c'};`"
                                >{{ getStatusState(status.id).remainingRounds == null ? '—' : formatBuffDuration(getStatusState(status.id).remainingRounds) }}</span>
                            </div>
                        </template>
                        <div style="font-size:12px; line-height:1.6;">
                            <div v-for="effect in status.effects" :key="effect.id">{{ describeBuffEffect(effect) }}</div>
                        </div>
                    </v-tooltip>
                    <v-row no-gutters align="center" style="margin-top:10px;">
                        <v-col cols="6" class="pr-1">
                            <v-text-field v-model="character.characterData.commonStatusDuration.value" label="Duration" type="number" min="1" placeholder="None" hide-details dense></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-select v-model="character.characterData.commonStatusDuration.unit" :items="statusDurationUnits" label="Unit" hide-details dense></v-select>
                        </v-col>
                    </v-row>
                    <div style="font-size:11px; color:#5d4037; margin-top:4px;">Applied when a status is checked.</div>
                </div>
                <v-menu
                    v-model="buffTimeMenu.show"
                    :position-x="buffTimeMenu.x"
                    :position-y="buffTimeMenu.y"
                    :close-on-content-click="false"
                    absolute
                >
                    <v-list dense>
                        <v-list-item v-for="option in buffTimeMenuOptions" :key="option.label" @click="adjustBuffTime(option.rounds)" style="min-height:28px;">
                            <v-list-item-title style="font-size:13px;">{{ option.label }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-text>
        </v-card>
    </div>

    <buff-management-dialog
        v-model="buffsDoc"
        :character-data="character.characterData"
        :point-trackers="pointTrackers"
    ></buff-management-dialog>

    <v-dialog v-model="trackerDoc" max-width="80%">
        <v-card style="background-color:#DEB887">
            <v-card-title class="headline" style="margin-bottom:24px"><div>Edit Point Trackers</div><v-spacer/><v-btn @click="addPointTracker()">Add</v-btn></v-card-title>
            <v-card-text>
                <draggable :list="pointTrackers" :group="{ name: 'pointTracker', put:false, pull:false}" handle=".drag-handle">
                    <v-row v-for="tracker in pointTrackers" :key="tracker.id" style="display:flex;align-items:center; margin-bottom:16px; border-style: solid; border-color:grey; border-width: 2px;" class="mx-2 pt-2 pb-2">
                            <v-icon style="margin-top:8px" class="mx-2 drag-handle">drag_handle</v-icon>
                            <v-text-field v-model="tracker.name" label="Name" hide-details="true" class="mx-2"></v-text-field>
                            <v-text-field v-model="tracker.value" label="Current" hide-details="true" class="mx-2"></v-text-field>
                            <v-text-field
                                v-model="tracker.max"
                                label="Max"                            
                                hide-details="true"
                                class="mx-2"
                                @focus="beginTrackerMaxEdit(tracker)"
                                @keyup.enter="commitTrackerMaxEdit(tracker)"
                                @change="finishTrackerMaxEdit(tracker)"
                            ></v-text-field>
                            <v-text-field v-model="tracker.default" label="Default" hide-details="true" class="mx-2"></v-text-field>
                            <v-checkbox v-model="tracker.showAsPip" label="Show as pip" hide-details dense class="mx-2 mt-0"></v-checkbox>
                            <v-checkbox v-model="tracker.showAsBar" label="Show as bar" hide-details dense class="mx-2 mt-0"></v-checkbox>
                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        class="mx-2"
                                        :title="`Overlay color for ${tracker.name}`"
                                        :style="{ backgroundColor: tracker.color, border: '2px solid white' }"
                                    >
                                        <v-icon small color="white">palette</v-icon>
                                    </v-btn>
                                </template>
                                <v-color-picker
                                    v-model="tracker.color"
                                    mode="hexa"
                                    hide-mode-switch
                                    show-swatches
                                ></v-color-picker>
                            </v-menu>
                            <v-icon @click="removePointTracker(tracker)" style="margin-top:12px" class="mx-2">delete_forever</v-icon>
                    </v-row>
                </draggable>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="savingSettingsDialog" max-width="800">
        <v-card style="background-color:#DEB887">
            <div style="display:flex; justify-content:space-around"><span>Character ID: {{uuid}}</span> <span>Character Name: {{character.characterName}}</span> <span>Owner: {{ownerName}}</span> <span>Locked: {{characterLocked}}</span></div>
            <v-card-title class="headline brown darken-4" style="color:antiquewhite; justify-content:center">
                <v-tabs v-model="saveLoadTab" background-color="headline brown darken-5" dark align-tabs="center" fixed-tabs>
                    <v-tab>Load</v-tab>
                    <v-tab>Save</v-tab>
                </v-tabs>
            </v-card-title>
            <v-card-text style="margin-top:16px;color:black!important">
                <v-tabs-items v-model="saveLoadTab" style="background-color:transparent; width:100%; padding-left:16px; padding-bottom:16px;">
                    <v-tab-item>
                        <div style="display:flex; align-items:baseline; margin-top:16px">
                            <v-btn @click="handleLoadFromID">Load From ID</v-btn> <v-text-field v-model="newUuid" hide-details="true" style="max-width:300px; margin-left:16px"></v-text-field>
                        </div>
                        <div style="display:flex; align-items:baseline; margin-top:32px">
                            <v-btn @click="handleLoadFromName">Load From Character Name</v-btn> <v-text-field v-model="newName" hide-details="true" style="max-width:300px; margin-left:16px"></v-text-field>
                        </div>
                        <v-btn style="margin-top:32px" @click="handleLoad">Upload From File</v-btn><br/>
                        <div style="display:flex; align-items:baseline; margin-top:32px">
                            <v-btn @click="LoadCharacterList">Load From Owner Name</v-btn> <v-text-field v-model="newOwnerName" hide-details="true" style="max-width:300px; margin-left:16px"></v-text-field>
                        </div>
                        <div v-if="showCharacterList">
                            <v-list>
                                <v-list-item v-for="character in filteredCharacterList" :key="character.id">
                                    <v-btn @click="newUuid = character.id; handleLoadFromID()">{{ character.character_name }}</v-btn>
                                </v-list-item>
                            </v-list>
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div style="display:flex; align-items:center; margin-top:32px">
                            <v-btn @click="onlineSave(true)" :disabled="uuid.length < 1">Save to Server</v-btn>
                        </div>
                        <div style="display:flex; align-items:center; margin-top:32px">
                            Owner: <v-text-field v-model="newOwnerName" hide-details="true" style="max-width:300px; margin-left:16px"></v-text-field>
                            <v-checkbox v-model="characterLocked" hide-details="true" label="Character Locked"></v-checkbox>
                        </div>
                        <div style="display:flex; align-items:baseline; margin-top:32px">
                            <v-btn @click="saveToServer">New Database Character</v-btn> <v-text-field v-model="newName" hide-details="true" style="max-width:300px; margin-left:16px"></v-text-field>
                        </div>
                        <div style="display:flex; align-items:center; margin-top:32px">
                            <v-btn @click="downloadAsFile">Download as File</v-btn>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                
                <div style="display:flex; justify-content:space-around; margin-top:16px">
                    <v-checkbox style="margin-top:16px;" v-model="autoSavingToServer" hide-details="true" label="Auto Save To Server"></v-checkbox>
                    <v-checkbox style="margin-top:16px;" v-model="autoUpdateFromServer" hide-details="true" label="Auto Update From Server"></v-checkbox>
                </div>

                <v-btn style="margin-top:32px; margin-bottom:16px;" @click="clearCharacter">Clear Character</v-btn><br/>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-alert v-model="saveStatus.show" :type="saveStatus.type" closable style="position:fixed; right:16px; bottom:16px; z-index:202; max-width:300px">
        <div style="margin-right:24px">{{saveStatus.message}}</div>
        <v-icon @click="saveStatus.show = false" style="position:absolute; right:16px; top:16px">mdi-close</v-icon>
    </v-alert>

    <!-- Hotkeys Dialog -->
    <hotkeys-dialog v-model="hotkeysDialog"></hotkeys-dialog>

    </div>
  </v-container>
</template>

<script>
import {psychePowers} from './psychePowers'
import characterSheet from './characterSheet.vue'
import maneuverTracker from './maneuverTracker.vue'
import spellTracker from './spellTracker.vue'
import hotkeysDialog from './hotkeysDialog.vue'
import psychicDuels from './psychicDuels.vue'
import BuffManagementDialog from './BuffManagementDialog.vue'
import buffUtilities from './buffUtilities.js';
import draggable from 'vuedraggable';
import {maneuvers as maneuverDB} from "../../play/daba/maneuvers"
import { createClient } from '@supabase/supabase-js';
import { characterSheetStructure } from './characterSheetStructure';
import {
    CHARACTER_SECTIONS,
    applyCharacterPatches,
    cloneJson,
    createCharacterPatches,
    createSnapshotPatches,
    snapshotFromRow,
} from './characterRealtimeSync';
import utilities from './utilities';
import PrivateConnector from './privateConnector.js'
export default {
  components: {
    draggable,
    characterSheet,
    maneuverTracker,
    spellTracker,
    hotkeysDialog,
    psychicDuels,
    BuffManagementDialog,
  },
  data() {
    return {
        utilities,
        psychePowers,
        connection:{},
        tab:0,
        saveLoadTab:0,
        saveStatus:{
            show:false,
            type:"success",
            message:"",
            id:0,
        },
        ownerName: "",
        newOwnerName:"",
        characterLocked:false,
        characterList:[],
        showCharacterList:false,
        character: characterSheetStructure,
        autoSavingToServer:true,
        autoUpdateFromServer:true,
        changes:{character_data:false,sticky_windows:false,maneuver_tracker:false,spell_tracker:false,psyche:false},
        lastChange:{character_data:null,sticky_windows:null,maneuver_tracker:null,spell_tracker:null,psyche:null},
        supabaseUrl: 'https://kbjjqssxridfwtqjwquo.supabase.co',
        supabaseKey: 'sb_publishable_PspCtMt73rIksYz1s0DhJw_SoC43B_U',
        supabase: null,
        characterRealtimeChannel:null,
        characterRealtimeUuid:"",
        characterSubscriptionPromise:null,
        realtimeRetryTimeout:null,
        syncClientId:"",
        syncRevision:-1,
        serverSnapshot:null,
        serverCharacterName:null,
        serverLocked:null,
        isApplyingServerState:false,
        autoSaveTimeout:null,
        saveInFlight:false,
        saveQueued:false,
        queuedForcedSave:false,
        realtimeRefreshInFlight:false,
        realtimeRefreshQueued:false,
        loadGeneration:0,
        isDestroyed:false,
        tempTracker:0,
        trackerMaxEdit:null,
        savingSettingsDialog:false,
        newUuid:"",
        newName:"",
        uuid: "",
        pointTrackers: characterSheetStructure.stickyWindows.pointTrackers,
        quickDetailsData: characterSheetStructure.stickyWindows.quickDetailsData,
        
        stickyTracker:false,
        trackerDoc:false,
        trackerPosition: { x: 500, y: 100 }, // Initial position
        stickyNotes:false,
        notesPosition: { x: 500, y: 100 }, // Initial position
        quickDetails:false,
        quickDetailsPosition: { x: 500, y: 100 }, // Initial position
        stickyBuffs:false,
        buffsDoc:false,
        buffsPosition: { x: 500, y: 100 }, // Initial position
        buffPanelTab: 0,
        commonStatuses: buffUtilities.COMMON_STATUSES,
        statusDurationUnits: buffUtilities.DURATION_UNITS,
        buffTimeMenu: { show: false, x: 0, y: 0, target: null },
        buffTimeMenuOptions: [
            { label: '+1 Hour', rounds: 600 },
            { label: '+1 Minute', rounds: 10 },
            { label: '+1 Round', rounds: 1 },
            { label: '-1 Round', rounds: -1 },
            { label: '-1 Minute', rounds: -10 },
            { label: '-1 Hour', rounds: -600 },
        ],
        tempQuickValue: 0,
        isDragging: false,
        dragDelay: false,
        dragOffset: { x: 0, y: 0 },
        draggingElement: null, // Track which element is being dragged
        maneuverDB: maneuverDB,
        
        // Peer-to-peer connection
        privateConnector: null,
        isConnectedToAdmin: false,
        connectionStatus: 'Disconnected',
        adminConnectionTimer: null,
        connectionCheckTimer: null,
        connectionHealthTimer: null,
        
        // Dialog states
        hotkeysDialog: false,
        
        // Resize observer for notes
        notesResizeObserver: null,
        notesResizeObserverSetup: false,
        pendingRoll20Requests: {},
    };
  },
  beforeMount(){
    this.character = JSON.parse(JSON.stringify(characterSheetStructure))
    this.normalizePointTrackers()
    this.normalizeBuffs()
    this.pointTrackers = this.character.stickyWindows.pointTrackers
    this.quickDetailsData = this.character.stickyWindows.quickDetailsData
  },
  mounted(){
    window.addEventListener('message', this.handleRoll20Result);
    this.supabase = createClient(this.supabaseUrl, this.supabaseKey)
    this.syncClientId = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`
    
    let params = new URLSearchParams(location.search)
    let uuid = params.get('uuid')

    if(uuid){
        this.uuid = uuid
        this.newUuid = uuid
        this.handleLoadFromID()
        this.autoSavingToServer = true
    }
    // this.searchManeuver = "gutstrike"
    // this.addManeuver()

    // this.searchManeuver = "Black Seraph's Glare"
    // this.addManeuver()

    // this.searchManeuver = "Voracious Drive"
    // this.addManeuver()

    //window.addEventListener("mouseup", this.addDaily)
    
    // Add keyboard shortcuts
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
    this.syncCalculatedDefenseTotals()

    window.addEventListener('contextmenu', function(ev) {
        ev.preventDefault();
        return false;
    }, false);
  },
  computed:{
    filteredCharacterList(){
      return this.characterList.filter(character => character.character_name.toLowerCase().includes(this.newName.toLowerCase()))
    },
    personalBuffTabIds() {
      const tabs = (this.character && this.character.characterData && this.character.characterData.buffTabs) || [];
      return [buffUtilities.MAIN_BUFF_TAB, ...tabs];
    },
    buffPanelTabIds() {
      return [...this.personalBuffTabIds, '__common__'];
    },
    activeBuffPanelId() {
      return this.buffPanelTabIds[this.buffPanelTab] || buffUtilities.MAIN_BUFF_TAB;
    },
    isCommonStatusBuffPanel() {
      return this.activeBuffPanelId === '__common__';
    },
    visiblePanelBuffs() {
      if (this.isCommonStatusBuffPanel) return [];
      const tab = this.activeBuffPanelId;
      return ((this.character && this.character.characterData && this.character.characterData.buffs) || [])
        .filter(buff => buffUtilities.getBuffTab(buff) === tab);
    },
    maneuverInfo(){
      //comboTagsWithExtra
      let tagInfo = []
      let obj = {count:0,types:{Strike:0,Boost:0,Counter:0,Stance:0},levels:[],id:Math.random(),mastery:0}
      for(let x = 0; x < 10; x++){
        obj.levels[x] = {level:x,count:0}
      }
      obj = JSON.stringify(obj)

      this.comboTagText.concat(['elementalFlux','solarWind']).forEach(comboTag=>{
        let tempObj = JSON.parse(obj)
        tempObj.name = comboTag
        tempObj.id = Math.random()
        tagInfo.push(tempObj)
      })
      let allManeuvers = Object.values(this.knownManeuvers).reduce((acc, levelArray) => acc.concat(levelArray), []);

      allManeuvers.forEach(maneuver=>{
        if(maneuver.type != "Finisher"){
          let tags
          if(maneuver.school == "solarWind") tags = [maneuver.school]
          else if(maneuver.school == "elementalFlux") tags = ["elementalFlux","Arcane"]
          else tags = this.comboTags[maneuver.school]
          if(maneuver.additionalTags) tags = tags.concat(maneuver.additionalTags)
          tags.forEach(tag=>{
            let db = tagInfo.find(tagDb=> tagDb.name == tag)
            db.count += 1
            db.types[maneuver.type] += 1
            let mastery = parseInt(maneuver.level)
            if(db.levels[maneuver.level].count == 0 && maneuver.basic == false) mastery *= 2
            if(mastery > 9) mastery = 9
            if(tag == "elementalFlux" || maneuver.basic) mastery = Math.ceil(mastery/2)
            db.mastery += mastery
            db.levels[maneuver.level].count += 1

          })
        }
      })
      if(this.comboSortBy != "Alphabetic"){
        tagInfo = tagInfo.sort(function(a, b){return b.mastery-a.mastery})
      }
      return tagInfo
    },
    isMozilla(){
      return navigator.userAgent.search("Firefox") > 1
    },
  },
    methods:{
        convertTextToNumber(text) {
            if(!text || text.length < 1) text = "";
            const numbers = text.match(/[+-]?\d+/g) || [];
            return numbers.reduce((sum, num) => sum + parseInt(num), 0);
        },
        getTotalDiceSettingsCount() {
            if (!this.character?.characterData?.offense?.diceSettings) return 0;
            const settings = this.character.characterData.offense.diceSettings;
            let count = 0;
            if (settings.rerollAttacks?.enabled) count++;
            if (settings.rerollConfirmations?.enabled) count++;
            if (settings.missChance?.enabled) count++;
            if (settings.fortification?.enabled) count++;
            if (settings.ignorePrecision?.enabled) count++;
            return count;
        },
        handleKeyboardShortcuts(event) {
            // Check if Ctrl key is pressed for panel toggles
            if (event.ctrlKey && !event.shiftKey) {
                switch (event.key) {
                    case '1':
                        event.preventDefault();
                        this.quickDetails = !this.quickDetails;
                        break;
                    case '2':
                        event.preventDefault();
                        this.stickyTracker = !this.stickyTracker;
                        break;
                    case '3':
                        event.preventDefault();
                        this.stickyNotes = !this.stickyNotes;
                        break;
                    case '4':
                        event.preventDefault();
                        this.stickyBuffs = !this.stickyBuffs;
                        break;
                }
            }
            
            // Check if Alt key is pressed for main tab navigation
            if (event.altKey && !event.shiftKey) {
                switch (event.key) {
                    case '1':
                        event.preventDefault();
                        this.tab = 0; // Character Sheet
                        break;
                    case '2':
                        event.preventDefault();
                        this.tab = 1; // Maneuver Tracker
                        break;
                    case '3':
                        event.preventDefault();
                        this.tab = 2; // Spell Tracker
                        break;
                }
            }
        },


        parseDamage(str) {
            if (!str) return { dice: '', mod: 0 };
            str = str.trim().replace(/\s+/g, '');
            const terms = str.match(/([+-]?\d+d\d+|[+-]?\d+)/gi) || [];
            const diceTerms = [];
            let mod = 0;
            terms.forEach(term => {
                if (term.includes('d')) {
                diceTerms.push(/^[+-]/.test(term) ? term : '+' + term);
                } else {
                mod += parseInt(term) || 0;
                }
            });
            diceTerms.sort((a, b) => parseInt(b.split('d')[1]) - parseInt(a.split('d')[1]));
            const dice = diceTerms.join('').replace(/^\+/, '');
            return { dice, mod };
        },

        getTotalDamageBonus(damageBonusName) {
            const db = this.character.characterData.offense.damageBonuses.find(d => d.name === damageBonusName);
            if (!db) return "0";
            let modTotal = Object.entries(db.abilityModifiers).reduce((acc, [abil, {modifies, multiplier=1}]) => 
                acc + (modifies ? Math.floor(this.character.characterData.abilities[abil].modifiedModifier * multiplier) : 0), 0);
            const bonuses = ['enhancementBonus', 'luckBonus', 'moraleBonus', 'profaneBonus', 'sacredBonus', 'insightBonus', 'untypedBonus', 'competenceBonus', 'feat', 'sizeModifier'];
            modTotal += bonuses.reduce((sum, key) => sum + (parseInt(db[key]) || 0), 0);
            ['miscModifiers', 'tempModifiers'].forEach(field => {
                if (db[field]) modTotal += (db[field].match(/[+-]?\d+/g) || []).reduce((s, n) => s + parseInt(n), 0);
            });
            const buffDamage = buffUtilities.getDamageBuffParts(
                this.character.characterData,
                db,
                this.pointTrackers
            );
            modTotal += buffDamage.modifier;
            const dice = buffUtilities.stepBaseDamageDice(
                db.dice || "",
                buffUtilities.getDamageDiceStepTotal(this.character.characterData)
            );
            return buffUtilities.combineDamageExpressions(
                dice,
                { dice: buffDamage.dice, modifier: modTotal }
            );
        },

         getSelectedDamageCalculations() {
             const selectedAttacks = this.character.characterData.offense.attacks.filter(attack => attack.showInDetails);
             return selectedAttacks.map(attack => {
                 // Get damage text from selected damage bonus, or fall back to attack.damage
                 let baseDamage = '';
                 let damageBonus = null;
                 
                 if (attack.damageBonusName) {
                     damageBonus = this.character.characterData.offense.damageBonuses.find(db => db.name === attack.damageBonusName);
                     baseDamage = this.getTotalDamageBonus(attack.damageBonusName) || '';
                 }
                 if (!baseDamage && attack.damage) {
                     baseDamage = this.getBuffedRawDamage(attack.damage);
                 }
                 if (!baseDamage) {
                     baseDamage = 'No damage calculation';
                 }
 
                 // Pre-calculate combined values to avoid re-computation on every render
                 const combinedAttackBonus = this.calculateCombinedAttackBonus(attack);
                 const combinedDamageText = this.calculateCombinedDamageText(attack, baseDamage);
                 
                 return {
                    weapon: attack.weapon || 'Unnamed Weapon',
                    attackBonus: attack.attackBonus,  // Original base
                    damageText: baseDamage,  // Base only
                    damage: attack.damage,  // Raw damage field
                    damageBonusName: attack.damageBonusName,  // For character sheet method
                    criticalRange: attack.criticalRange,
                    criticalMult: attack.criticalMult,
                    criticalConfirmBonus: attack.criticalConfirmBonus,
                    nonMultipliedDamage: this.calculateDamageSectionText(
                        damageBonus?.nonMultipliedDamage || attack.nonMultipliedDamage || '',
                        'nonMultipliedDamage'
                    ),
                    precision: this.calculateDamageSectionText(
                        damageBonus?.precision || attack.precision || '',
                        'precision'
                    ),
                    criticalBonusDamage: this.calculateDamageSectionText(
                        damageBonus?.bonusCriticalDamage || attack.criticalBonusDamage || '',
                        'criticalDamage'
                    ),
                    tempAttackModifiers: attack.tempAttackModifiers || '',
                    tempDamageModifiers: attack.tempDamageModifiers || '',
                    combinedAttackBonus: combinedAttackBonus,
                    combinedDamageText: combinedDamageText,
                    buffEffectsResolved: true,
                    collapsed: attack.collapsed || false,  // Collapse state
                    originalAttack: attack
                 };
             });
         },

        copyAttackToClipboard(attack) {
            // Call the character sheet's copyAttackToClipboard method directly
            if (this.$refs.characterSheet && this.$refs.characterSheet.copyAttackToClipboard) {
                this.$refs.characterSheet.copyAttackToClipboard(attack);
            }
        },

        handleAttackDiceClick(event, attack) {
            if (!event.shiftKey) {
                this.copyAttackToClipboard(attack);
                return;
            }

            const sheet = this.$refs.characterSheet;
            if (!sheet || !sheet.buildAttackRollCommand) {
                this.showRoll20Status('error', 'Unable to build the Roll20 attack command.');
                return;
            }

            const requestId = typeof crypto !== 'undefined' && crypto.randomUUID
                ? crypto.randomUUID()
                : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
            const timeout = window.setTimeout(() => {
                if (!this.pendingRoll20Requests[requestId]) return;
                delete this.pendingRoll20Requests[requestId];
                this.showRoll20Status(
                    'error',
                    'The Akashic Paths extension did not answer. Confirm it is installed and reloaded.'
                );
            }, 3000);
            this.pendingRoll20Requests[requestId] = timeout;

            window.postMessage({
                source: 'akashic-paths',
                type: 'roll20-roll',
                requestId,
                command: sheet.buildAttackRollCommand(attack),
            }, window.location.origin);
        },

        handleRoll20Result(event) {
            if (event.source !== window || event.origin !== window.location.origin) return;
            const data = event.data;
            if (
                !data ||
                data.source !== 'akashic-paths-extension' ||
                data.type !== 'roll20-roll-result' ||
                typeof data.requestId !== 'string' ||
                !this.pendingRoll20Requests[data.requestId]
            ) {
                return;
            }

            window.clearTimeout(this.pendingRoll20Requests[data.requestId]);
            delete this.pendingRoll20Requests[data.requestId];
            this.showRoll20Status(
                data.ok ? 'success' : 'error',
                data.ok
                    ? 'Attack sent to Roll20.'
                    : data.error || 'Unable to send the attack to Roll20.'
            );
        },

        showRoll20Status(type, message) {
            this.saveStatus = {
                type,
                message,
                show: true,
                id: this.saveStatus.id + 1,
            };
        },
        
        handleCopyAttackToClipboard(attack) {
            // Call the character sheet's copyAttackToClipboard method
            if (this.$refs.characterSheet && this.$refs.characterSheet.copyAttackToClipboard) {
                this.$refs.characterSheet.copyAttackToClipboard(attack);
            }
        },

        updateTempAttackModifiers(quickDetailsIndex, value) {
            const selectedAttacks = this.character.characterData.offense.attacks.filter(attack => attack.showInDetails);
            if (selectedAttacks[quickDetailsIndex]) selectedAttacks[quickDetailsIndex].tempAttackModifiers = value;
        },

        updateTempDamageModifiers(quickDetailsIndex, value) {
            const selectedAttacks = this.character.characterData.offense.attacks.filter(attack => attack.showInDetails);
            if (selectedAttacks[quickDetailsIndex]) selectedAttacks[quickDetailsIndex].tempDamageModifiers = value;
        },
        
        toggleAttackCollapse(quickDetailsIndex) {
            const selectedAttacks = this.character.characterData.offense.attacks.filter(attack => attack.showInDetails);
            if (selectedAttacks[quickDetailsIndex]) {
                selectedAttacks[quickDetailsIndex].collapsed = !selectedAttacks[quickDetailsIndex].collapsed;
            }
        },

        calculateCombinedAttackBonus(attack) {
            // Split attack bonuses by / (e.g., "+10/+5/+0")
            const baseAttacks = attack.attackBonus.split('/');
            
            // Parse temp modifiers to get total numeric modifier
            let tempModifier = 0;
            if (attack.tempAttackModifiers) {
                tempModifier = (attack.tempAttackModifiers.match(/[+-]?\d+/g) || []).reduce((sum, num) => sum + parseInt(num), 0);
            }
            
            // Parse global attack modifier
            let globalModifier = 0;
            if (this.character.characterData.offense.globalAttackModifier) {
                globalModifier = (this.character.characterData.offense.globalAttackModifier.match(/[+-]?\d+/g) || []).reduce((sum, num) => sum + parseInt(num), 0);
            }
            
            // Apply temp, global, and active buff modifiers to each attack bonus
            const totalModifier = tempModifier
                + globalModifier
                + buffUtilities.getAttackBuffTotal(
                    this.character.characterData,
                    this.pointTrackers
                );
            const modifiedAttacks = baseAttacks.map(attackBonus => {
                const baseModifier = parseInt(attackBonus) || 0;
                const newModifier = baseModifier + totalModifier;
                return (newModifier >= 0 ? '+' : '') + newModifier;
            });
            
            return modifiedAttacks.join('/');
        },

        calculateCombinedDamageText(attack, baseDamage) {
            const tempDamage = attack.tempDamageModifiers || '';
            const globalDamage = this.character.characterData.offense.globalDamageModifier || '';
            
            if (!tempDamage && !globalDamage) return baseDamage;
            
            const { dice: baseDice, mod: baseMod } = this.parseDamage(baseDamage);
            const { dice: tempDice, mod: tempMod } = this.parseDamage(tempDamage);
            const { dice: globalDice, mod: globalMod } = this.parseDamage(globalDamage);
            
            const combinedDice = baseDice + (tempDice ? (baseDice ? '+' : '') + tempDice : '') + (globalDice ? (baseDice || tempDice ? '+' : '') + globalDice : '');
            const totalMod = baseMod + tempMod + globalMod;
            const modText = totalMod ? (totalMod > 0 ? `+${totalMod}` : `${totalMod}`) : '';
            return combinedDice ? (modText ? `${combinedDice}${modText}` : combinedDice) : (modText || '0');
        },

        getBuffedRawDamage(baseDamage) {
            const characterData = this.character.characterData;
            const steppedBase = buffUtilities.stepBaseDamageDice(
                baseDamage,
                buffUtilities.getDamageDiceStepTotal(characterData)
            );
            const buffDamage = buffUtilities.getDamageBuffParts(
                characterData,
                null,
                this.pointTrackers
            );
            return buffUtilities.combineDamageExpressions(
                steppedBase,
                { dice: buffDamage.dice, modifier: buffDamage.modifier }
            );
        },

        calculateDamageSectionText(baseDamage, target) {
            const buffDamage = buffUtilities.getDamageSectionBuffText(
                this.character.characterData,
                target,
                this.pointTrackers
            );
            if (buffDamage === '0') return baseDamage || '';
            return buffUtilities.combineDamageExpressions(baseDamage, buffDamage);
        },

        async migrateCharacters() {
            try {
                console.log('Starting character migration...');
                
                // Fetch all sheets from the maneuverTracker table
                const { data: oldSheets, error } = await this.supabase
                    .from('maneuverTracker')
                    .select('*');
                
                if (error) {
                    console.error('Error fetching old sheets:', error);
                    return;
                }
                
                console.log(`Found ${oldSheets.length} sheets to migrate`);

                console.log(JSON.parse(oldSheets[0].sheetData))
                
                let migratedCount = 0;
                let errorCount = 0;
                
                for (const oldSheet of oldSheets) {
                    try {
                        // Parse the old sheetData
                        const oldData = JSON.parse(oldSheet.sheetData);
                        
                        // Create new character with default structure
                        const newCharacter = JSON.parse(JSON.stringify(characterSheetStructure));
                        
                        // Migrate the data
                        this.migrateSheetData(oldData, newCharacter);
                        
                        // Save to character_sheet table
                        await this.saveMigratedCharacter(newCharacter, oldSheet);
                        
                        migratedCount++;
                        console.log(`Migrated: ${oldData.sheetName || 'Unknown Character'}`);
                        
                    } catch (migrationError) {
                        console.error(`Error migrating sheet ${oldSheet.id}:`, migrationError);
                        errorCount++;
                    }
                }
                
                console.log(`Migration complete: ${migratedCount} successful, ${errorCount} errors`);
                
            } catch (error) {
                console.error('Migration failed:', error);
            }
        },
        
        migrateSheetData(oldData, newCharacter) {
            // Set character name
            newCharacter.characterName = oldData.sheetName || 'Migrated Character';
            
            newCharacter.maneuverTracker.knownManeuvers = oldData.knownManeuvers
            newCharacter.maneuverTracker.readiedManeuvers = oldData.readiedManeuvers
            newCharacter.maneuverTracker.specials = oldData.specials
            newCharacter.maneuverTracker.combo = oldData.combo
            console.log("pointTrackers", oldData.pointTrackers)
            newCharacter.stickyWindows.pointTrackers = oldData.pointTrackers
                      
        },
        
        async saveMigratedCharacter(newCharacter, oldSheet) {
            try {
                const characterData = {
                    character_name: newCharacter.characterName,
                    character_data: newCharacter.characterData,
                    character_data_last_change: new Date().toISOString(),
                    sticky_windows: newCharacter.stickyWindows,
                    sticky_windows_last_change: new Date().toISOString(),
                    maneuver_tracker: newCharacter.maneuverTracker,
                    maneuver_tracker_last_change: new Date().toISOString(),
                    spell_tracker: newCharacter.spellTracker,
                    spell_tracker_last_change: new Date().toISOString(),
                    psyche: newCharacter.psyche,
                    psyche_last_change: new Date().toISOString(),
                    owner_name: oldSheet.owner_name || "Nate Dawg",
                    locked: oldSheet.locked || false,
                };
                
                const { data, error } = await this.supabase
                    .from('character_sheet')
                    .insert([characterData])
                    .select()
                    .single();
                
                if (error) throw error;
                
                console.log(`Created new character with ID: ${data.id}`);
                
            } catch (error) {
                console.error('Error saving migrated character:', error);
                throw error;
            }
        },
        normalizePointTrackers(){
            if (!this.character.stickyWindows) this.$set(this.character, 'stickyWindows', {})
            if (!Array.isArray(this.character.stickyWindows.pointTrackers)) {
                this.$set(this.character.stickyWindows, 'pointTrackers', [])
            }
            const hasElevation = this.character.stickyWindows.pointTrackers.some(tracker => {
                if (!tracker) return false
                return String(tracker.id).trim().toLowerCase() === 'elevation'
                    || String(tracker.name).trim().toLowerCase() === 'elevation'
            })
            if (!hasElevation) {
                this.character.stickyWindows.pointTrackers.push({
                    id:'elevation',
                    name:'Elevation',
                    value:0,
                    max:0,
                    default:0,
                    showAsPip:true,
                    showAsBar:false,
                    color:'#0EA5E9',
                })
            }
            this.character.stickyWindows.pointTrackers.forEach(tracker => {
                if (typeof tracker.showAsPip !== 'boolean') this.$set(tracker, 'showAsPip', false)
                if (typeof tracker.showAsBar !== 'boolean') this.$set(tracker, 'showAsBar', false)
                if (typeof tracker.color !== 'string' || !/^#[0-9a-f]{6}([0-9a-f]{2})?$/i.test(tracker.color)) {
                    this.$set(tracker, 'color', '#4ADE80')
                }
            })
        },
        normalizeBuffs(){
            if (!this.character.characterData) return
            const characterData = this.character.characterData
            if (!Array.isArray(characterData.buffTabs)) this.$set(characterData, 'buffTabs', [])
            if (!Array.isArray(characterData.buffs)) this.$set(characterData, 'buffs', [])
            const known = new Set([buffUtilities.MAIN_BUFF_TAB, ...characterData.buffTabs])
            characterData.buffs.forEach(buff => {
                if (!buff) return
                if (!buff.tab) this.$set(buff, 'tab', buffUtilities.MAIN_BUFF_TAB)
                if (buff.tab !== buffUtilities.MAIN_BUFF_TAB && !known.has(buff.tab)) {
                    characterData.buffTabs.push(buff.tab)
                    known.add(buff.tab)
                }
            })
            if (!characterData.commonStatusDuration) {
                this.$set(characterData, 'commonStatusDuration', { value: '', unit: 'rounds' })
            }
            if (this.buffPanelTab >= this.buffPanelTabIds.length) this.buffPanelTab = 0
        },
        buffPanelTabLabel(tab) {
            if (tab === '__common__') return 'Common Statuses'
            if (tab === buffUtilities.MAIN_BUFF_TAB) return 'Main'
            return tab
        },
        syncCalculatedDefenseTotals(){
            if (this.isApplyingServerState) return
            const sheet = this.$refs.characterSheet
            const defense = this.character
                && this.character.characterData
                && this.character.characterData.defense
            if (!sheet || !defense) return

            const armorClass = defense.ac
            if (armorClass) {
                const totals = {
                    total: Number(sheet.acTotal),
                    touch: Number(sheet.acTouch),
                    flatFooted: Number(sheet.acFlatFooted),
                }
                Object.entries(totals).forEach(([key, value]) => {
                    if (Number.isFinite(value) && Number(armorClass[key]) !== value) {
                        this.$set(armorClass, key, value)
                    }
                })
            }
            const savingThrows = defense.saves
            const saveTotals = sheet.saveTotals
            if (savingThrows && saveTotals) {
                Object.entries(saveTotals).forEach(([key, total]) => {
                    const save = savingThrows[key]
                    const value = Number(total)
                    if (save && Number.isFinite(value) && Number(save.total) !== value) {
                        this.$set(save, 'total', value)
                    }
                })
            }
        },
        snapshotNumber(value){
            const number = Number(value)
            return Number.isFinite(number) ? number : 0
        },
        normalizeSnapshotValue(value){
            if (Array.isArray(value)) {
                return value.map(item => this.normalizeSnapshotValue(item))
            }
            if (value && typeof value === 'object') {
                return Object.keys(value).sort().reduce((normalized, key) => {
                    normalized[key] = this.normalizeSnapshotValue(value[key])
                    return normalized
                }, {})
            }
            return value
        },
        snapshotValuesEqual(left, right){
            return JSON.stringify(this.normalizeSnapshotValue(left))
                === JSON.stringify(this.normalizeSnapshotValue(right))
        },
        buildPluginSnapshot(){
            const sheet = this.$refs.characterSheet
            const characterData = this.character && this.character.characterData
            if (!sheet || !characterData) return null

            const hp = characterData.defense && characterData.defense.hp
                ? characterData.defense.hp
                : {}
            const armorClass = {
                total: this.snapshotNumber(sheet.acTotal),
                touch: this.snapshotNumber(sheet.acTouch),
                flatFooted: this.snapshotNumber(sheet.acFlatFooted),
            }
            const savingThrows = {
                fortitude: this.snapshotNumber(sheet.saveTotals && sheet.saveTotals.fortitude),
                reflex: this.snapshotNumber(sheet.saveTotals && sheet.saveTotals.reflex),
                will: this.snapshotNumber(sheet.saveTotals && sheet.saveTotals.will),
            }
            const attacks = this.getSelectedDamageCalculations().map((attack, index) => {
                const sourceIndex = characterData.offense.attacks.indexOf(attack.originalAttack)
                const attackText = String(attack.combinedAttackBonus == null ? '' : attack.combinedAttackBonus)
                const damageText = String(attack.combinedDamageText == null ? '' : attack.combinedDamageText)
                const criticalRange = String(attack.criticalRange == null ? '' : attack.criticalRange)
                const criticalMult = String(attack.criticalMult == null ? '' : attack.criticalMult)
                return {
                    id: `attack-${sourceIndex >= 0 ? sourceIndex : index}`,
                    name: attack.weapon,
                    attackText,
                    damageText,
                    displayText: `${attack.weapon}: ${attackText} | ${damageText}/${criticalRange}${criticalMult}`,
                    command: sheet.buildAttackRollCommand(attack),
                    precisionText: attack.precision || undefined,
                }
            })
            const personalBuffs = (characterData.buffs || []).reduce((buffs, buff, index) => {
                if (!buff || !buff.active) return buffs
                buffs.push({
                    id: buff.id == null ? `buff-${index}` : String(buff.id),
                    name: typeof buff.name === 'string' && buff.name.trim()
                        ? buff.name.trim()
                        : 'Unnamed Buff',
                    remainingRounds: buff.remainingRounds == null
                        ? null
                        : this.snapshotNumber(buff.remainingRounds),
                    kind: 'buff',
                })
                return buffs
            }, [])
            const commonBuffs = buffUtilities.COMMON_STATUSES.reduce((buffs, status) => {
                const state = characterData.commonStatuses && characterData.commonStatuses[status.id]
                if (!state || !state.active) return buffs
                buffs.push({
                    id: status.id,
                    name: status.name,
                    remainingRounds: state.remainingRounds == null
                        ? null
                        : this.snapshotNumber(state.remainingRounds),
                    kind: 'status',
                })
                return buffs
            }, [])
            const pointTrackers = (
                this.character.stickyWindows
                && Array.isArray(this.character.stickyWindows.pointTrackers)
                    ? this.character.stickyWindows.pointTrackers
                    : []
            ).reduce((trackers, tracker, index) => {
                if (!tracker || (!tracker.showAsPip && !tracker.showAsBar)) return trackers
                trackers.push({
                    id: tracker.id == null ? `tracker-${index}` : String(tracker.id),
                    name: typeof tracker.name === 'string' && tracker.name.trim()
                        ? tracker.name.trim()
                        : 'Tracker',
                    value: this.snapshotNumber(tracker.value),
                    max: Math.max(0, this.snapshotNumber(tracker.max)),
                    showAsPip: tracker.showAsPip === true,
                    showAsBar: tracker.showAsBar === true,
                    color: tracker.color,
                })
                return trackers
            }, [])

            return {
                version: 1,
                hp: {
                    current: this.snapshotNumber(sheet.effectiveHpCurrent),
                    max: this.snapshotNumber(sheet.effectiveHpMax),
                    baseCurrent: this.snapshotNumber(hp.current),
                    baseMax: this.snapshotNumber(hp.max),
                    hpBuffTotal: this.snapshotNumber(sheet.hpBuffTotal),
                    temp: this.snapshotNumber(hp.temp),
                    nonLethal: this.snapshotNumber(hp.nonLethal),
                    delayed: this.snapshotNumber(hp.delayed),
                    delayedMax: this.snapshotNumber(hp.delayedMax),
                },
                armorClass,
                savingThrows,
                quickRolls: attacks,
                buffs: personalBuffs.concat(commonBuffs),
                pointTrackers,
            }
        },
        async updatePluginSnapshotAfterRender(){
            await new Promise(resolve => this.$nextTick(resolve))
            const snapshot = this.buildPluginSnapshot()
            if (!snapshot || this.snapshotValuesEqual(
                this.character.characterData.pluginSnapshot,
                snapshot
            )) return false

            this.$set(this.character.characterData, 'pluginSnapshot', snapshot)
            return true
        },
        addPointTracker(){
            this.pointTrackers.splice(this.pointTrackers.length, 0, {
                id:Math.random(),
                name:"New Point Tracker",
                value:0,
                max:0,
                default:0,
                showAsPip:false,
                showAsBar:false,
                color:"#4ADE80",
            })
        },
        removePointTracker(tracker){
            this.pointTrackers.splice(this.pointTrackers.indexOf(tracker), 1)
        },
        resetTrackers(){
            this.pointTrackers.forEach(tracker=>{
                tracker.value = tracker.default
            })
        },
        resetDay() {
            this.$refs.characterSheet?.resetDay?.()
            this.$refs.spellTracker?.resetAllSpells?.()
            this.$refs.maneuverTracker?.resetManeuvers?.('daily')
            this.resetTrackers()
        },
        doTrackerMath(tracker){
            if(tracker.value[0] == "+" || tracker.value[0] == "-"){
                tracker.value = parseInt(this.tempTracker) + parseInt(tracker.value)
                this.tempTracker = tracker.value;
                if(isNaN(tracker.value)) tracker.value = parseInt(this.tempTracker)
            }
            else{
                tracker.value = parseInt(this.tempTracker)
                this.tempTracker = 0
            }
        },
        beginTrackerMaxEdit(tracker){
            this.trackerMaxEdit = {
                id: tracker.id,
                baseline: Number.parseInt(tracker.max, 10) || 0,
            }
        },
        commitTrackerMaxEdit(tracker){
            const baseline = this.trackerMaxEdit && this.trackerMaxEdit.id === tracker.id
                ? this.trackerMaxEdit.baseline
                : Number.parseInt(tracker.max, 10) || 0
            tracker.max = utilities.applyRelativeIntegerInput(tracker.max, baseline, 0)
            this.trackerMaxEdit = {
                id: tracker.id,
                baseline: tracker.max,
            }
        },
        finishTrackerMaxEdit(tracker){
            if (this.trackerMaxEdit && this.trackerMaxEdit.id === tracker.id) {
                const parsed = Number.parseInt(tracker.max, 10)
                tracker.max = Number.isFinite(parsed) ? Math.max(0, parsed) : this.trackerMaxEdit.baseline
            }
            this.trackerMaxEdit = null
        },
        doQuickMath(field){
            let hpFields = this.character.characterData.defense.hp
            if(hpFields[field][0] == "+" || hpFields[field][0] == "-"){
                hpFields[field] = parseInt(this.tempQuickValue) + parseInt(hpFields[field])
                this.tempQuickValue = hpFields[field];
                if(isNaN(hpFields[field])) hpFields[field] = parseInt(this.tempQuickValue)
            }
            else{
                hpFields[field] = parseInt(this.tempQuickValue)
                this.tempQuickValue = 0
            }
        },
        checkQuickChange(field){
            let hpFields = this.character.characterData.defense.hp
            if(hpFields[field].length == 0){
                hpFields[field] = parseInt(this.tempQuickValue)
                this.tempQuickValue = 0
            }
        },
        updateDefenseFromModifiers(){
            // Update the character sheet's otherModifiers field
            this.character.characterData.defense.ac.otherModifiers = this.quickDetailsData.acModifiers;
        },
        checkChange(tracker){
            if(tracker.value.length == 0){
                tracker.value = parseInt(this.tempTracker)
                this.tempTracker = 0
            }
        },
        createSpecialId(type,subType, index){
            return type + ","+ subType + "," + index
        },

        downloadAsFile() {
            if(this.character.characterName == "Character Name") return;
            
            // Create complete character data object to save
            const saveData = {
                character_name: this.character.characterName,
                owner_name: this.ownerName,
                locked: this.characterLocked,
                should_connect: this.character.should_connect,
                character_data: JSON.stringify(this.character.characterData),
                sticky_windows: JSON.stringify(this.character.stickyWindows),
                maneuver_tracker: JSON.stringify(this.character.maneuverTracker),
                spell_tracker: JSON.stringify(this.character.spellTracker),
                psyche: JSON.stringify(this.character.psyche)
            };

            // Convert to JSON string
            const jsonString = JSON.stringify(saveData, null, 2);

            // Create blob and download link
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            
            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = this.character.characterName + '_character_save.json';
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },

        async saveToServer() {
            if(this.newName == "Character Name" || this.newName == "Must have a Name (2+ characters)" || this.newName.length < 2) {
                this.newName = "Must have a Name (2+ characters)";
                return;
            }
            const characterName = this.newName
            const loadGeneration = ++this.loadGeneration
            this.newName = ""
            try {
                // First check if a character with this name already exists for the same owner
                const { data: existingCharacter, error: checkError } = await this.supabase
                    .from('character_sheet')
                    .select('*')
                    .eq('character_name', characterName)
                    .eq('owner_name', this.ownerName) // Add owner check
                    .single();

                if (checkError && checkError.code !== 'PGRST116') { // PGRST116 is "no rows returned" error
                    throw checkError;
                }
                if (loadGeneration !== this.loadGeneration) return

                if (existingCharacter) {
                    this.sheetName = ""
                    this.newName = ""
                    console.error('A character with this name already exists');
                    this.saveStatus = {
                        type: 'error',
                        message: 'A character with this name already exists',
                        show: true,
                        id:this.saveStatus.id+1
                    };
                    return;
                }

                this.syncCalculatedDefenseTotals()
                await this.updatePluginSnapshotAfterRender()
                const submittedSnapshot = this.getCurrentCharacterSnapshot()
                let characterData = {
                    character_name: characterName,
                    character_data: submittedSnapshot.character_data,
                    character_data_last_change: new Date().toISOString(),
                    sticky_windows: submittedSnapshot.sticky_windows,
                    sticky_windows_last_change: new Date().toISOString(),
                    maneuver_tracker: submittedSnapshot.maneuver_tracker,
                    maneuver_tracker_last_change: new Date().toISOString(),
                    spell_tracker: submittedSnapshot.spell_tracker,
                    spell_tracker_last_change: new Date().toISOString(),
                    psyche: submittedSnapshot.psyche,
                    psyche_last_change: new Date().toISOString()
                }
                
                if(this.newOwnerName.length > 0) characterData.owner_name = this.newOwnerName
                if(this.characterLocked) characterData.locked = true

                // If no existing character, create new one
                const { data: newCharacter, error: createError } = await this.supabase
                    .from('character_sheet')
                    .insert([characterData])
                    .select()
                    .single();

                if (createError) throw createError;
                if (loadGeneration !== this.loadGeneration) return

                // Store the new UUID
                await this.stopCharacterSubscription()
                if (loadGeneration !== this.loadGeneration) return
                this.uuid = newCharacter.id;
                this.resetCharacterSyncState()
                this.processServerRow(newCharacter, true, {
                    snapshot: submittedSnapshot,
                    characterName,
                    locked: this.characterLocked,
                })
                this.$nextTick(() => {
                    if (this.hasUnsavedChanges()) this.scheduleAutoSave()
                })
                void this.subscribeToCharacter(this.uuid, loadGeneration).catch(error => {
                    console.error('Unable to subscribe to character Realtime updates:', error)
                    this.scheduleRealtimeReconnect()
                })
                window.history.replaceState(null, null, "?uuid=" + this.uuid)

                // Show success message
                this.saveStatus = {
                    type: 'success',
                    message: 'Character created successfully',
                    show: true,
                    id:this.saveStatus.id+1
                };
            } catch (error) {
                console.error('Error creating character:', error);
                this.saveStatus = {
                    type: 'error',
                    message: 'Failed to create character',
                    show: true,
                    id:this.saveStatus.id+1
                };
            }
        },

        resetCharacterSyncState() {
            if (this.autoSaveTimeout) clearTimeout(this.autoSaveTimeout)
            this.autoSaveTimeout = null
            this.syncRevision = -1
            this.serverSnapshot = null
            this.serverCharacterName = null
            this.serverLocked = null
            this.saveQueued = false
            this.queuedForcedSave = false
            this.realtimeRefreshQueued = false
            Object.keys(this.changes).forEach(key => {
                this.changes[key] = false
                this.lastChange[key] = null
            })
        },

        getCurrentCharacterSnapshot() {
            const snapshot = {}
            CHARACTER_SECTIONS.forEach(section => {
                snapshot[section.dataKey] = cloneJson(this.character[section.stateKey])
            })
            return snapshot
        },

        captureAcknowledgedState() {
            if (!this.serverSnapshot) return null
            return {
                snapshot: cloneJson(this.serverSnapshot),
                characterName: this.serverCharacterName,
                locked: this.serverLocked,
                mergeMetadata: true,
            }
        },

        async stopCharacterSubscription() {
            if (this.realtimeRetryTimeout) clearTimeout(this.realtimeRetryTimeout)
            this.realtimeRetryTimeout = null
            const channel = this.characterRealtimeChannel
            this.characterRealtimeChannel = null
            this.characterRealtimeUuid = ""
            this.characterSubscriptionPromise = null
            if (channel && this.supabase) {
                void this.supabase.removeChannel(channel).catch(error => {
                    console.error('Unable to remove character Realtime channel:', error)
                })
            }
        },

        scheduleRealtimeReconnect() {
            if (
                this.isDestroyed
                || this.realtimeRetryTimeout
                || !this.autoUpdateFromServer
                || !this.uuid
            ) return
            const characterId = this.uuid
            this.realtimeRetryTimeout = setTimeout(async () => {
                this.realtimeRetryTimeout = null
                if (
                    this.isDestroyed
                    || !this.autoUpdateFromServer
                    || String(this.uuid) !== String(characterId)
                ) return
                try {
                    await this.subscribeToCharacter(characterId)
                    await this.fetchCharacterRow(characterId)
                } catch (error) {
                    console.error('Unable to reconnect character Realtime updates:', error)
                    this.scheduleRealtimeReconnect()
                }
            }, 5000)
        },

        async subscribeToCharacter(characterId, loadGeneration = null) {
            if (
                this.isDestroyed
                || !this.autoUpdateFromServer
                || !characterId
                || !this.supabase
            ) return
            if (
                this.characterRealtimeChannel
                && String(this.characterRealtimeUuid) === String(characterId)
            ) {
                return this.characterSubscriptionPromise || undefined
            }

            await this.stopCharacterSubscription()
            if (
                this.isDestroyed
                || (loadGeneration !== null && loadGeneration !== this.loadGeneration)
            ) return
            const channel = this.supabase
                .channel(`character-sheet-${characterId}-${this.syncClientId}`)
                .on(
                    'postgres_changes',
                    {
                        event: 'UPDATE',
                        schema: 'public',
                        table: 'character_sheet',
                        filter: `id=eq.${characterId}`,
                    },
                    payload => {
                        if (
                            !this.isDestroyed
                            && String(payload.new.id) === String(this.uuid)
                        ) {
                            this.handleRealtimeCharacterRow(payload.new)
                        }
                    }
                )

            this.characterRealtimeChannel = channel
            this.characterRealtimeUuid = characterId

            const subscriptionPromise = new Promise((resolve, reject) => {
                let subscribedOnce = false
                const subscriptionTimeout = window.setTimeout(() => {
                    reject(new Error('Character Realtime subscription timed out'))
                }, 10000)
                const settle = callback => value => {
                    window.clearTimeout(subscriptionTimeout)
                    callback(value)
                }
                const resolveSubscription = settle(resolve)
                const rejectSubscription = settle(reject)
                channel.subscribe((status, error) => {
                    if (status === 'SUBSCRIBED') {
                        if (subscribedOnce) this.handleAutoLoad()
                        subscribedOnce = true
                        resolveSubscription()
                    }
                    else if (
                        status === 'CHANNEL_ERROR'
                        || status === 'TIMED_OUT'
                        || status === 'CLOSED'
                    ) {
                        if (subscribedOnce) {
                            if (this.characterRealtimeChannel === channel) {
                                this.characterRealtimeChannel = null
                                this.characterRealtimeUuid = ""
                                this.characterSubscriptionPromise = null
                                this.scheduleRealtimeReconnect()
                            }
                        } else {
                            const cause = error && error.message
                                ? `: ${error.message}`
                                : ''
                            rejectSubscription(new Error(
                                `Character Realtime subscription failed: ${status}${cause}`
                            ))
                        }
                    }
                })
            })
            this.characterSubscriptionPromise = subscriptionPromise

            try {
                await subscriptionPromise
                if (
                    this.isDestroyed
                    || (loadGeneration !== null && loadGeneration !== this.loadGeneration)
                ) {
                    if (this.characterRealtimeChannel === channel) {
                        await this.stopCharacterSubscription()
                    }
                    return
                }
            } catch (error) {
                if (this.characterRealtimeChannel === channel) {
                    this.characterRealtimeChannel = null
                    this.characterRealtimeUuid = ""
                    this.characterSubscriptionPromise = null
                }
                await this.supabase.removeChannel(channel)
                throw error
            } finally {
                if (this.characterRealtimeChannel === channel) {
                    this.characterSubscriptionPromise = null
                }
            }
        },

        async prepareCharacterSync(characterId, loadGeneration = null) {
            if (
                this.isDestroyed
                || (loadGeneration !== null && loadGeneration !== this.loadGeneration)
            ) return false
            if (String(this.uuid) !== String(characterId)) {
                await this.stopCharacterSubscription()
                if (
                    this.isDestroyed
                    || (loadGeneration !== null && loadGeneration !== this.loadGeneration)
                ) return false
                this.resetCharacterSyncState()
            }
            this.uuid = characterId
            if (this.autoUpdateFromServer) {
                void this.subscribeToCharacter(characterId, loadGeneration).catch(error => {
                    console.error('Unable to subscribe to character Realtime updates:', error)
                    this.scheduleRealtimeReconnect()
                })
            }
            return !this.isDestroyed
                && (loadGeneration === null || loadGeneration === this.loadGeneration)
        },

        normalizeServerSnapshot(serverSnapshot) {
            const snapshot = cloneJson(serverSnapshot)
            CHARACTER_SECTIONS.forEach(section => {
                snapshot[section.dataKey] = this.mergeWithDefaults(
                    snapshot[section.dataKey],
                    cloneJson(characterSheetStructure[section.stateKey])
                )
            })
            this.handleLoadManeuverTracker(snapshot.maneuver_tracker)
            if (snapshot.psyche && snapshot.psyche.powers) {
                this.handleLoadPsychePowers(snapshot.psyche.powers)
            }
            if (snapshot.character_data) {
                buffUtilities.normalizeBuffTabs(snapshot.character_data)
            }
            return snapshot
        },

        handleRealtimeCharacterRow(row) {
            if (
                !row
                || String(row.id) !== String(this.uuid)
                || (
                    row.sync_revision != null
                    && Number(row.sync_revision) <= this.syncRevision
                )
            ) return
            this.realtimeRefreshQueued = true
            this.refreshCharacterFromServer()
        },

        async refreshCharacterFromServer() {
            if (
                this.isDestroyed
                || this.saveInFlight
                || this.realtimeRefreshInFlight
                || !this.uuid
            ) return

            this.realtimeRefreshInFlight = true
            try {
                while (this.realtimeRefreshQueued && !this.isDestroyed && !this.saveInFlight) {
                    this.realtimeRefreshQueued = false
                    await this.fetchCharacterRow(this.uuid)
                }
            } catch (error) {
                console.error('Error refreshing Realtime character data:', error)
                this.realtimeRefreshQueued = true
                this.scheduleRealtimeReconnect()
            } finally {
                this.realtimeRefreshInFlight = false
            }
        },

        processServerRow(row, forceApply = false, acknowledgedState = null) {
            if (this.isDestroyed || !row || String(row.id) !== String(this.uuid)) return

            const revision = Number(row.sync_revision || 0)
            if (this.serverSnapshot && revision <= this.syncRevision) return

            const hadSnapshot = this.serverSnapshot !== null
            const hasSectionBaseline = hadSnapshot || (
                acknowledgedState && acknowledgedState.snapshot
            )
            const localPatches = hasSectionBaseline
                ? createCharacterPatches(
                    acknowledgedState ? acknowledgedState.snapshot : this.serverSnapshot,
                    this.character
                )
                : []
            const hasMetadataBaseline = hadSnapshot || (
                acknowledgedState && acknowledgedState.mergeMetadata
            )
            const localNameChanged = hasMetadataBaseline
                && this.character.characterName !== (
                    acknowledgedState ? acknowledgedState.characterName : this.serverCharacterName
                )
            const localLockedChanged = hasMetadataBaseline
                && this.characterLocked !== (
                    acknowledgedState ? acknowledgedState.locked : this.serverLocked
                )
            const persistedSnapshot = snapshotFromRow(row)
            CHARACTER_SECTIONS.forEach(section => {
                if (persistedSnapshot[section.dataKey] == null && hadSnapshot) {
                    persistedSnapshot[section.dataKey] = cloneJson(
                        this.serverSnapshot[section.dataKey]
                    )
                }
            })
            const remotePatches = hadSnapshot
                ? createSnapshotPatches(this.serverSnapshot, persistedSnapshot)
                : []
            const incomingSnapshot = this.normalizeServerSnapshot(persistedSnapshot)
            const mergedSnapshot = applyCharacterPatches(incomingSnapshot, localPatches)
            const shouldApply = forceApply
                || this.autoUpdateFromServer
                || row.sync_updated_by === this.syncClientId

            this.serverSnapshot = persistedSnapshot
            this.serverCharacterName = row.character_name
            this.serverLocked = row.locked
            this.syncRevision = revision
            CHARACTER_SECTIONS.forEach(section => {
                this.lastChange[section.dataKey] = row[section.lastChangeKey] || null
                this.changes[section.dataKey] = localPatches.some(
                    patch => patch.section === section.dataKey
                )
            })

            if (!shouldApply) return

            this.isApplyingServerState = true
            const changedSections = new Set(remotePatches.map(patch => patch.section))
            CHARACTER_SECTIONS.forEach(section => {
                if (!hadSnapshot || forceApply || changedSections.has(section.dataKey)) {
                    this.character[section.stateKey] = cloneJson(mergedSnapshot[section.dataKey])
                }
            })
            if (!localNameChanged) this.character.characterName = row.character_name
            if (!localLockedChanged) this.characterLocked = row.locked
            this.character.should_connect = row.should_connect || false
            this.ownerName = row.owner_name
            document.title = `(${this.character.characterName})`
            this.refreshCharacterAliases()
            this.$nextTick(() => {
                this.isApplyingServerState = false
                this.syncCalculatedDefenseTotals()
                void this.updatePluginSnapshotAfterRender().then(snapshotChanged => {
                    if (snapshotChanged) this.markCharacterSectionChanged('character_data')
                }).catch(error => {
                    console.error('Unable to update plugin snapshot after hydration:', error)
                })
            })
        },

        refreshCharacterAliases() {
            this.normalizePointTrackers()
            this.normalizeBuffs()
            this.pointTrackers = this.character.stickyWindows.pointTrackers
            this.quickDetailsData = this.character.stickyWindows.quickDetailsData
            this.spellTracker = this.character.spellTracker
            this.maneuverTracker = this.character.maneuverTracker
            this.psyche = this.character.psyche
            this.characterData = this.character.characterData
            this.stickyWindows = this.character.stickyWindows
        },

        async fetchCharacterRow(
            characterId,
            forceApply = false,
            loadGeneration = null,
            acknowledgedState = null
        ) {
            const { data, error } = await this.supabase
                .from('character_sheet')
                .select('*')
                .eq('id', characterId)
                .single()
            if (error) throw error
            if (loadGeneration !== null && loadGeneration !== this.loadGeneration) return null
            this.processServerRow(data, forceApply, acknowledgedState)
            return data
        },

        async restorePreviousCharacter(characterId, acknowledgedState, loadGeneration) {
            try {
                await this.prepareCharacterSync(characterId, loadGeneration)
                await this.fetchCharacterRow(
                    characterId,
                    true,
                    loadGeneration,
                    acknowledgedState
                )
            } catch (error) {
                console.error('Error restoring the previous character:', error)
                if (loadGeneration === this.loadGeneration) {
                    await this.stopCharacterSubscription()
                    this.resetCharacterSyncState()
                    this.uuid = ""
                }
            }
        },

        async handleLoadFromID() {
            const characterId = this.newUuid || this.uuid
            const previousCharacterId = this.serverSnapshot ? this.uuid : ""
            const previousState = this.captureAcknowledgedState()
            const loadGeneration = ++this.loadGeneration
            let transitionStarted = false
            try {
                transitionStarted = true
                const prepared = await this.prepareCharacterSync(characterId, loadGeneration)
                if (!prepared) return
                if (loadGeneration !== this.loadGeneration) return
                const data = await this.fetchCharacterRow(characterId, true, loadGeneration)
                if (!data) return
                this.uuid = data.id
                this.newUuid = ""
                this.newName = ""
                window.history.replaceState(null, null, "?uuid=" + this.uuid)
            } catch (error) {
                console.error('Error loading character:', error)
                if (
                    transitionStarted
                    && previousCharacterId
                    && loadGeneration === this.loadGeneration
                ) {
                    await this.restorePreviousCharacter(
                        previousCharacterId,
                        previousState,
                        loadGeneration
                    )
                } else if (loadGeneration === this.loadGeneration && transitionStarted) {
                    await this.stopCharacterSubscription()
                    this.resetCharacterSyncState()
                    this.uuid = ""
                }
            }
            this.showCharacterList = false
            this.characterList = []
        },

        async handleAutoLoad() {
            if (!this.uuid) return
            try {
                await this.fetchCharacterRow(this.uuid)
            } catch (error) {
                console.error('Error loading character:', error)
            }
        },

        mergeWithDefaults(data, defaults) {
            if (!defaults) return data;
            if (!data) return defaults;
            
            // Handle arrays properly
            if (Array.isArray(defaults)) {
                if (Array.isArray(data)) {
                    // Check if this is a skills array (has objects with 'name' and 'ability' properties)
                    if (data.length > 0 && defaults.length > 0 && 
                        typeof data[0] === 'object' && data[0].name && data[0].ability && 
                        typeof defaults[0] === 'object' && defaults[0].name && defaults[0].ability) {
                        return this.mergeSkillsArray(data, defaults);
                    }
                    
                    // For other arrays, merge by index position
                    return this.mergeArrayByIndex(data, defaults);
                } else {
                    // Default is array but data is not - return default
                    return [...defaults];
                }
            }
            
            // Handle objects
            if (typeof defaults === 'object' && defaults !== null) {
                const merged = { ...defaults };
                
                // Recursively merge objects
                for (const key in data) {
                    if (Object.prototype.hasOwnProperty.call(data, key)) {
                        if (typeof data[key] === 'object' && data[key] !== null && 
                            typeof defaults[key] === 'object' && defaults[key] !== null) {
                            merged[key] = this.mergeWithDefaults(data[key], defaults[key]);
                        } else {
                            merged[key] = data[key];
                        }
                    }
                }
                
                return merged;
            }
            
            // For primitive values, return data if it exists, otherwise defaults
            return data !== undefined ? data : defaults;
        },

        // Specialized function to merge skills arrays by matching skill names
        mergeSkillsArray(dataSkills, defaultSkills) {
            // Safety check - ensure these are actually skills (have ability property)
            if (dataSkills.length > 0 && !dataSkills[0].ability) {
                console.warn('mergeSkillsArray called on non-skill array, falling back to default merging');
                return this.mergeArrayByIndex(dataSkills, defaultSkills);
            }
            
            const mergedSkills = [];
            const defaultMap = new Map();
            const usedDefaults = new Set();
            
            // Create a map of default skills with keys based on name and specific (if applicable)
            defaultSkills.forEach(defaultSkill => {
                const key = defaultSkill.name.toLowerCase() + 
                    (defaultSkill.needsSpecific && defaultSkill.specific ? 
                     '-' + defaultSkill.specific.toLowerCase() : '');
                defaultMap.set(key, defaultSkill);
            });
            
            // Go through data skills: merge with matching default if exists, or add as-is (for extras)
            dataSkills.forEach(dataSkill => {
                const key = dataSkill.name.toLowerCase() + 
                    (dataSkill.needsSpecific && dataSkill.specific ? 
                     '-' + dataSkill.specific.toLowerCase() : '');
                
                // Run migrations on the raw data BEFORE merging with defaults
                const skillCopy = { ...dataSkill };
                this.migrateRacialTraitValues(skillCopy);
                this.migrateAbilityModifiers(skillCopy);
                
                if (defaultMap.has(key)) {
                    // Merge: use default as base, override with data (and recurse if needed)
                    const defaultSkill = defaultMap.get(key);
                    const mergedSkill = this.mergeWithDefaults(skillCopy, defaultSkill);
                    
                    // Restore original ability if it was preserved during migration
                    
                    mergedSkills.push(mergedSkill);
                    usedDefaults.add(key);
                } else {
                    // Extra skill not in defaults: preserve as-is
                    mergedSkills.push(skillCopy);
                }
            });
            
            // Add any missing defaults
            defaultSkills.forEach(defaultSkill => {
                const key = defaultSkill.name.toLowerCase() + 
                    (defaultSkill.needsSpecific && defaultSkill.specific ? 
                     '-' + defaultSkill.specific.toLowerCase() : '');
                if (!usedDefaults.has(key)) {
                    mergedSkills.push({ ...defaultSkill });
                }
            });
            
            return mergedSkills;
        },

        // Helper method to migrate racial and trait values to race_trait
        migrateRacialTraitValues(skill) {
            // Check if race_trait is empty or 0, and if racial or trait have values
            const raceTraitValue = parseInt(skill.race_trait) || 0;
            const racialValue = parseInt(skill.racial) || 0;
            const traitValue = parseInt(skill.trait) || 0;
            
            // If race_trait is empty/0 but racial or trait have values, combine them
            if (raceTraitValue === 0 && (racialValue !== 0 || traitValue !== 0)) {
                skill.race_trait = racialValue + traitValue;
                
                // Clear the old values to avoid confusion
                skill.racial = 0;
                skill.trait = 0;
            }
        },

        // Helper method to migrate skills without abilityModifiers section
        migrateAbilityModifiers(skill) {
            // Check if abilityModifiers section is missing
            if (!skill.abilityModifiers) {
                // Create the abilityModifiers structure with all abilities set to false
                skill.abilityModifiers = {
                    strength: {modifies: false, multiplier: 1},
                    dexterity: {modifies: false, multiplier: 1},
                    constitution: {modifies: false, multiplier: 1},
                    intelligence: {modifies: false, multiplier: 1},
                    wisdom: {modifies: false, multiplier: 1},
                    charisma: {modifies: false, multiplier: 1}
                };
                
                // Set the correct ability to modifies: true based on the skill's ability
                if (skill.ability && skill.abilityModifiers[skill.ability]) {
                    skill.abilityModifiers[skill.ability].modifies = true;
                }
                skill.ability = characterSheetStructure.characterData.skills.adventuring.concat(characterSheetStructure.characterData.skills.background).find(s=>s.name == skill.name).ability || skill.ability
            } else {
                // If abilityModifiers already exists, preserve the original ability field
                // Store the original ability in a special property to restore after merging
                
                // Find the first ability that has modifies: true
                const activeAbilities = [];
                for (const ability of ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']) {
                    if (skill.abilityModifiers[ability] && skill.abilityModifiers[ability].modifies) {
                        activeAbilities.push(ability);
                    }
                }
                
                // If there are active abilities, set the primary ability to the first one
                // This preserves the existing abilityModifiers configuration
                if (activeAbilities.length > 0) {
                    skill.ability = activeAbilities[0];
                }
            }
        },

        // Fallback function for merging arrays by index (original behavior)
        mergeArrayByIndex(data, defaults) {
            const mergedArray = [];
            for (let i = 0; i < Math.max(data.length, defaults.length); i++) {
                if (i < data.length && i < defaults.length) {
                    // Merge data element with default element
                    mergedArray.push(this.mergeWithDefaults(data[i], defaults[i]));
                } else if (i < data.length) {
                    // Only data exists - use as-is
                    mergedArray.push(data[i]);
                } else {
                    // Only default exists - use as-is
                    mergedArray.push(defaults[i]);
                }
            }
            return mergedArray;
        },

        // Persist owner name in a cookie for one year
        setOwnerNameCookie(name) {
            try {
                const encoded = encodeURIComponent(name);
                document.cookie = `ownerName=${encoded}; path=/; max-age=31536000; SameSite=Lax`;
            } catch (e) {
                console.warn('Unable to set ownerName cookie', e);
            }
        },

        // Retrieve owner name from cookie (if present)
        getOwnerNameFromCookie() {
            try {
                const match = document.cookie.match(/(?:^|; )ownerName=([^;]*)/);
                return match ? decodeURIComponent(match[1]) : '';
            } catch (e) {
                console.warn('Unable to read ownerName cookie', e);
                return '';
            }
        },


        async LoadCharacterList() {
            try {
                let ownerName = (this.newOwnerName && this.newOwnerName.trim().length > 0)
                    ? this.newOwnerName.trim()
                    : this.getOwnerNameFromCookie();

                if (ownerName && ownerName.length > 0) {
                    this.setOwnerNameCookie(ownerName);
                    this.newOwnerName = ownerName;
                }

                const { data, error } = await this.supabase
                    .from('character_sheet')
                    .select('character_name, id')
                    .eq('owner_name', ownerName)

                if (error) throw error;
                if (data) {
                    this.characterList = data
                    this.showCharacterList = true
                } else {
                    console.error('No character found with that ID');
                }
            } catch (error) {
                console.error('Error loading character:', error);
            }
        },

        async handleLoadFromName() {
            const previousCharacterId = this.serverSnapshot ? this.uuid : ""
            const previousState = this.captureAcknowledgedState()
            const loadGeneration = ++this.loadGeneration
            let transitionStarted = false
            try {
                let query = this.supabase
                    .from('character_sheet')
                    .select('*')
                    .eq('character_name', this.newName);

                if (this.newOwnerName && this.newOwnerName.length > 0) {
                    // If newOwnerName has a value, load where ID matches AND owner_name equals newOwnerName
                    query = query.eq('owner_name', this.newOwnerName);
                } else {
                    // If no newOwnerName, load where ID matches AND owner_name is null/empty AND not locked
                    query = query.eq('locked', false);
                }

                const { data, error } = await query.single();

                if (error) throw error;
                if (loadGeneration !== this.loadGeneration) return
                
                if (data) {
                    transitionStarted = true
                    const prepared = await this.prepareCharacterSync(data.id, loadGeneration)
                    if (!prepared) return
                    if (loadGeneration !== this.loadGeneration) return
                    this.processServerRow(data, true)
                    this.newUuid = ""
                    this.newName = ""
                    window.history.replaceState(null, null, "?uuid=" + this.uuid)
                } else {
                    alert("No character found with that name")
                    console.error('No character found with that name');
                }
            } catch (error) {
                console.error('Error loading character:', error);
                if (
                    transitionStarted
                    && previousCharacterId
                    && loadGeneration === this.loadGeneration
                ) {
                    await this.restorePreviousCharacter(
                        previousCharacterId,
                        previousState,
                        loadGeneration
                    )
                } else if (loadGeneration === this.loadGeneration && transitionStarted) {
                    await this.stopCharacterSubscription()
                    this.resetCharacterSyncState()
                    this.uuid = ""
                }
            }
        },

        markCharacterSectionChanged(sectionKey) {
            if (this.isApplyingServerState) return
            this.changes[sectionKey] = true
            this.lastChange[sectionKey] = new Date().toISOString()
            this.scheduleAutoSave()
        },

        scheduleAutoSave(delayMs = 1500) {
            if (
                this.isDestroyed
                || this.isApplyingServerState
                || !this.autoSavingToServer
                || !this.uuid
            ) return
            if (this.autoSaveTimeout) clearTimeout(this.autoSaveTimeout)
            this.autoSaveTimeout = setTimeout(() => {
                this.autoSaveTimeout = null
                this.onlineSave(false)
            }, Math.max(0, Number(delayMs) || 0))
        },

        refreshChangeFlags() {
            if (!this.serverSnapshot) return
            const pendingPatches = createCharacterPatches(this.serverSnapshot, this.character)
            Object.keys(this.changes).forEach(key => {
                this.changes[key] = pendingPatches.some(patch => patch.section === key)
            })
        },

        hasUnsavedChanges() {
            if (!this.serverSnapshot) return false
            return createCharacterPatches(this.serverSnapshot, this.character).length > 0
                || this.character.characterName !== this.serverCharacterName
                || this.characterLocked !== this.serverLocked
        },

        async onlineSave(forced = false) {
            if (this.isDestroyed) return
            if (this.autoSaveTimeout) clearTimeout(this.autoSaveTimeout)
            this.autoSaveTimeout = null

            if(this.uuid.length < 1 || this.character.characterName.length < 2) {
                this.saveStatus = {
                    type: 'error',
                    message: 'Must have a Name (2+ characters) and a Character ID',
                    show: true,
                    id:this.saveStatus.id+1
                };
                return;
            }

            if (!this.serverSnapshot) {
                this.saveStatus = {
                    type: 'error',
                    message: 'Load the server character before saving changes',
                    show: true,
                    id:this.saveStatus.id+1
                }
                return
            }

            if (this.saveInFlight) {
                this.saveQueued = true
                this.queuedForcedSave = this.queuedForcedSave || forced
                return
            }

            this.syncCalculatedDefenseTotals()
            await this.updatePluginSnapshotAfterRender()
            if (this.isDestroyed) return

            const patches = createCharacterPatches(this.serverSnapshot, this.character)
            const nameChanged = this.character.characterName !== this.serverCharacterName
            const lockedChanged = this.characterLocked !== this.serverLocked

            if (patches.length === 0 && !nameChanged && !lockedChanged) {
                if (forced) {
                    this.saveStatus = {
                        type: 'success',
                        message: 'Changes saved successfully',
                        show: true,
                        id:this.saveStatus.id+1
                    }
                }
                return
            }

            const acknowledgedState = {
                snapshot: applyCharacterPatches(this.serverSnapshot, patches),
                characterName: this.character.characterName,
                locked: this.characterLocked,
                mergeMetadata: true,
            }
            let conflictRetryDelayMs = null
            this.saveInFlight = true
            try {
                const { data, error } = await this.supabase
                    .rpc('patch_character_sheet', {
                        p_id: String(this.uuid),
                        p_patches: patches,
                        p_client_id: this.syncClientId,
                        p_expected_revision: this.syncRevision,
                        p_character_name: nameChanged ? this.character.characterName : null,
                        p_locked: lockedChanged ? this.characterLocked : null,
                    })
                    .single()

                if (error) throw error
                this.processServerRow(data, true, acknowledgedState)
                if (this.isDestroyed) return

                if (forced) {
                    this.saveStatus = {
                        type: 'success',
                        message: 'Changes saved successfully',
                        show: true,
                        id:this.saveStatus.id+1
                    }
                }
            } catch (error) {
                if (this.isDestroyed) return
                if (error.code === 'PT409' || error.code === '40001') {
                    conflictRetryDelayMs = 60_000
                    try {
                        await this.fetchCharacterRow(this.uuid, true)
                    } catch (refreshError) {
                        console.error('Error rebasing character changes:', refreshError)
                    }
                    return
                }
                console.error('Error saving character:', error)
                this.saveStatus = {
                    type: 'error',
                    message: 'Failed to save changes: ' + error.message,
                    show: true,
                    id:this.saveStatus.id+1
                }
            } finally {
                this.saveInFlight = false
                if (this.isDestroyed) {
                    this.realtimeRefreshQueued = false
                } else {
                    this.refreshChangeFlags()
                    const runForcedSave = this.queuedForcedSave
                    const shouldRunAgain = this.saveQueued || this.hasUnsavedChanges()
                    this.saveQueued = false
                    this.queuedForcedSave = false
                    if (conflictRetryDelayMs !== null) {
                        if (shouldRunAgain && this.autoSavingToServer) {
                            this.scheduleAutoSave(conflictRetryDelayMs)
                        }
                    } else if (runForcedSave) this.$nextTick(() => this.onlineSave(true))
                    else if (shouldRunAgain && this.autoSavingToServer) this.scheduleAutoSave()
                    else if (this.autoSaveTimeout) {
                        clearTimeout(this.autoSaveTimeout)
                        this.autoSaveTimeout = null
                    }
                    if (this.realtimeRefreshQueued) this.refreshCharacterFromServer()
                }
            }
        },


        handleLoad() {
            // Create file input
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.json';
            
            input.onchange = (e) => {
                const file = e.target.files[0];
                const reader = new FileReader();
                
                reader.onload = (event) => {
                    const data = JSON.parse(event.target.result);
                    this.handleLoadData(data)
                };
                
                reader.readAsText(file);
            };
            
            // Trigger file input
            input.click();
        },
        handleLoadData(data) {
            try {
            this.character.characterName = data.character_name;
            document.title = '(' + this.character.characterName + ')'
            this.ownerName = data.owner_name;
            this.characterLocked = data.locked;
            this.character.should_connect = data.should_connect || false;

            const sections = [
                { key: 'characterData', dataKey: 'character_data' },
                { key: 'stickyWindows', dataKey: 'sticky_windows' },
                { key: 'maneuverTracker', dataKey: 'maneuver_tracker' },
                { key: 'spellTracker', dataKey: 'spell_tracker' },
                { key: 'psyche', dataKey: 'psyche' }
            ];

            if(data.should_connect){
                this.initializeAdminConnection()
            }

            sections.forEach(section => {
                if (data[section.dataKey]) {
                    console.log("loading", data[section.dataKey])
                    // Handle both string (from file) and object (from Supabase)
                    let loadedData = data[section.dataKey];
                    if (typeof loadedData === 'string') {
                        loadedData = JSON.parse(loadedData);
                    }
                    const defaultStructure = characterSheetStructure[section.key];
                    const mergedData = this.mergeWithDefaults(loadedData, defaultStructure);
                    this.character[section.key] = mergedData;
                } else {
                    this.character[section.key] = JSON.parse(JSON.stringify(characterSheetStructure[section.key]));
                }
            });

            // Update lastChange timestamps
            Object.keys(this.lastChange).forEach(key => {
                this.lastChange[key] = new Date().toISOString();
            });

            this.handleLoadManeuverTracker(this.character.maneuverTracker);
            
            // Update separate data properties
            this.normalizePointTrackers()
            this.normalizeBuffs()
            this.pointTrackers = this.character.stickyWindows.pointTrackers;
            this.quickDetailsData = this.character.stickyWindows.quickDetailsData;
            this.spellTracker = this.character.spellTracker;
            this.maneuverTracker = this.character.maneuverTracker;
            this.psyche = this.character.psyche;
            if(this.psyche.powers){
                this.handleLoadPsychePowers(this.psyche.powers)
            }
            this.characterData = this.character.characterData;
            this.stickyWindows = this.character.stickyWindows;
            this.$nextTick(() => this.syncCalculatedDefenseTotals())
            } catch (error) {
                console.error('Error parsing save file:', error);
                alert('Error loading save file. Please ensure it is a valid JSON file.');
            }
        },

        handleLoadManeuverTracker(data){
            if (data.knownManeuvers) {
                data.knownManeuvers = this.updateDesc(data.knownManeuvers, true);
            }
            if (data.readiedManeuvers) {
                data.readiedManeuvers = this.updateDesc(data.readiedManeuvers);
            }
            if (data.specials) {
                // Update each type of special maneuvers and regenerate their IDs
                ['encounter', 'daily'].forEach(type => {
                    if (data.specials[type]) {
                        data.specials[type].typeList.forEach(subType => {
                            const specialManeuver = data.specials[type][subType];
                            data.specials[type][subType] = this.updateDesc([specialManeuver])[0];
                            data.specials[type][subType + 'Id'] = Math.random(); // Regenerate IDs
                        });
                    }
                });
            }
        },
        handleLoadPsychePowers(powers){
            powers.forEach(power=>{
                let foundPower = this.psychePowers.find(p=>p.name == power.name)
                if(foundPower){
                    if(power.description !== foundPower.description){
                        power.oldDesc = power.description
                        power.description = foundPower.description
                        power.updated = true
                    }
                }
            })
        },
        updateDesc(maneuverLists, isKnown){
            Object.keys(maneuverLists).forEach(key=>{
                // Ensure the value is an array before calling forEach
                if (Array.isArray(maneuverLists[key])) {
                    maneuverLists[key].forEach(maneuver=>{
                       let foundManeuver = this.maneuverDB.find(m=>m.name == maneuver.name)
                       if(foundManeuver){
                            if(isKnown && ((foundManeuver.gameDesc && maneuver.gameDesc !== foundManeuver.gameDesc) || (!foundManeuver.gameDesc && maneuver.longDesc !== foundManeuver.longDesc))) {
                                maneuver.updated = true
                                maneuver.oldDesc = maneuver.gameDesc ? maneuver.gameDesc : maneuver.longDesc
                            }
                            
                            maneuver.longDesc = foundManeuver.longDesc
                            if(foundManeuver.gameDesc) maneuver.longDesc = foundManeuver.gameDesc
                            if(!maneuver.basic) maneuver.basic = false
                       }
                    })
                } else {
                    // If it's not an array, convert it to an empty array
                    console.warn(`Maneuver list for key ${key} is not an array, converting to empty array`);
                    maneuverLists[key] = [];
                }
            })
            return maneuverLists
        },
        clearCharacter(){
            this.loadGeneration += 1
            document.title = 'Akashic Paths'
            let windowUrl = window.location.href
            windowUrl = windowUrl.replace("?uuid=" + this.uuid, "")
            window.history.replaceState(null, null, windowUrl)

            this.stopCharacterSubscription()
            this.resetCharacterSyncState()
            this.isApplyingServerState = true
            this.character = JSON.parse(JSON.stringify(characterSheetStructure))
            this.uuid = ""
            this.character.characterName = "Character Name"
            this.newName = ""
            this.newUuid = ""
            this.ownerName = ""
            this.newOwnerName = ""
            this.autoSavingToServer = false
            this.autoUpdateFromServer = false
            
            // Reset the separate data properties that reference character data
            this.pointTrackers = this.character.stickyWindows.pointTrackers
            this.quickDetailsData = this.character.stickyWindows.quickDetailsData
            this.spellTracker = this.character.spellTracker
            this.maneuverTracker = this.character.maneuverTracker
            this.psyche = this.character.psyche
            this.characterData = this.character.characterData
            this.stickyWindows = this.character.stickyWindows
            this.$nextTick(() => {
                this.isApplyingServerState = false
            })
        },

        startDrag(event) {
            // Determine which element is being dragged
            const targetId = event.target.id;
            if ((targetId === "stickyNotes" || targetId === "stickyTracker" || targetId === "quickDetails" || targetId === "stickyBuffs") && !this.isDragging) {
                this.isDragging = true;
                this.draggingElement = targetId;
                
                // Get mouse or touch position
                const clientX = event.clientX || (event.touches && event.touches[0].clientX);
                const clientY = event.clientY || (event.touches && event.touches[0].clientY);
                
                // Calculate offset from the current transform position based on which element
                const currentPosition = targetId === "stickyNotes" ? this.notesPosition :
                                    targetId === "quickDetails" ? this.quickDetailsPosition :
                                    targetId === "stickyBuffs" ? this.buffsPosition :
                                    this.trackerPosition;
                this.dragOffset = {
                x: clientX - currentPosition.x,
                y: clientY - currentPosition.y
                };
                
                // Add move and end event listeners with proper binding
                window.addEventListener('mousemove', this.onDrag, { passive: false });
                window.addEventListener('touchmove', this.onDrag, { passive: false });
                window.addEventListener('mouseup', this.stopDrag);
                window.addEventListener('touchend', this.stopDrag);
                
                // Prevent default to avoid text selection during drag
                event.preventDefault();
            }
        },
        onDrag(event) {
            if (!this.isDragging || this.dragDelay || !this.draggingElement) return;
            
            // Get mouse or touch position
            const clientX = event.clientX || (event.touches && event.touches[0].clientX);
            const clientY = event.clientY || (event.touches && event.touches[0].clientY);
            
            // Update position using transform based on which element is being dragged
            const newPosition = {
                x: clientX - this.dragOffset.x,
                y: clientY - this.dragOffset.y
            };
            
            if (this.draggingElement === "stickyNotes") {
                this.notesPosition = newPosition;
            } else if (this.draggingElement === "stickyTracker") {
                this.trackerPosition = newPosition;
            } else if (this.draggingElement === "quickDetails") {
                this.quickDetailsPosition = newPosition;
            } else if (this.draggingElement === "stickyBuffs") {
                this.buffsPosition = newPosition;
            }
            
            setTimeout(() => {
                this.dragDelay = false;
            }, 10);
            this.dragDelay = true;

            // Prevent default to avoid text selection during drag
            event.preventDefault();
        },
        stopDrag() {
            this.isDragging = false;
            this.draggingElement = null;
            
            // Remove event listeners
            window.removeEventListener('mousemove', this.onDrag);
            window.removeEventListener('touchmove', this.onDrag);
            window.removeEventListener('mouseup', this.stopDrag);
            window.removeEventListener('touchend', this.stopDrag);
        },

        setupNotesResizeObserver() {
            if (this.$refs.notesTextarea && window.ResizeObserver) {
                this.notesResizeObserver = new ResizeObserver((entries) => {
                    // Ignore the first resize event (initial setup)
                    if (!this.notesResizeObserverSetup) {
                        this.notesResizeObserverSetup = true;
                        return;
                    }
                    
                    for (let entry of entries) {
                        const { width, height } = entry.contentRect;
                        
                        // Save the new dimensions
                        this.character.stickyWindows.notesWidth = Math.round(width);
                        this.character.stickyWindows.notesHeight = Math.round(height);
                    }
                });
                
                this.notesResizeObserver.observe(this.$refs.notesTextarea);
            }
        },

        cleanupNotesResizeObserver() {
            if (this.notesResizeObserver) {
                this.notesResizeObserver.disconnect();
                this.notesResizeObserver = null;
                this.notesResizeObserverSetup = false;
            }
        },

        // Peer-to-peer connection methods
        async initializeAdminConnection() {
            this.privateConnector = new PrivateConnector()
            
            try {
                // Initialize the sender connection and wait for it to be ready
                await this.privateConnector.initializeSenderConnection()
                
                // Now get the peer ID
                const characterPeerId = this.privateConnector.getPeerConnectionId()
                if (characterPeerId) {
                    // Send connection request to server
                    await this.requestAdminConnection(characterPeerId)
                    
                    // Start checking for admin response
                    this.startAdminConnectionCheck()
                } else {
                    console.warn('No peer ID available after initialization')
                }
            } catch (error) {
                console.error('Error initializing admin connection:', error)
            }
        },

        async requestAdminConnection(characterPeerId) {
            try {
                const response = await fetch('/api/HttpTrigger1', {
                    method: "POST",
                    body: JSON.stringify({
                        command: "requestAdminConnection",
                        characterId: this.uuid,
                        characterName: this.character.characterName,
                        characterPeerId: characterPeerId
                    }),
                })
                
                if (response.ok) {
                    console.log('Admin connection request sent')
                }
            } catch (error) {
                console.error('Failed to request admin connection:', error)
            }
        },

        startAdminConnectionCheck() {
            // Clear any existing timer first
            if (this.connectionCheckTimer) {
                clearInterval(this.connectionCheckTimer)
            }
            
            // Check for admin response every 5 seconds
            this.connectionCheckTimer = setInterval(async () => {
                if (!this.isConnectedToAdmin) {
                    await this.checkForAdminConnection()
                } 
            }, 30000)
        },

        async checkForAdminConnection() {
            try {
                const response = await fetch('/api/HttpTrigger1', {
                    method: "POST",
                    body: JSON.stringify({
                        command: "getPlayerConnectionId",
                        characterId: this.uuid
                    }),
                })
                
                if (response.ok) {
                    const connectionId = await response.text()
                    
                    if (connectionId && connectionId !== 'no_connection_id') {
                        // Connect to admin using the specific connection ID
                        await this.connectToAdmin(connectionId)
                    } else {
                        // If no connection ID is available, resend the connection request
                        if (this.privateConnector) {
                            const characterPeerId = this.privateConnector.getPeerConnectionId()
                            if (characterPeerId) {
                                await this.requestAdminConnection(characterPeerId)
                            } else {
                                console.warn('No peer ID available, cannot resend connection request')
                            }
                        }
                    }
                } else {
                    console.log('Server response not ok:', response.status)
                }
            } catch (error) {
                console.error('Failed to check for admin connection:', error)
            }
        },

        async connectToAdmin(adminConnectionId) {
            try {
                await this.privateConnector.connectToAdmin(
                    adminConnectionId,
                    this.onAdminMessage,
                    this.onAdminConnect,
                    this.onAdminDisconnect
                )
            } catch (error) {
                console.error('Failed to connect to admin:', error)
            }
        },

        onAdminMessage(data) {
            console.log('Received message from admin:', data)
            // Handle admin messages here
        },

        onAdminConnect() {
            this.isConnectedToAdmin = true
            this.connectionStatus = 'Connected'
            console.log('Connected to admin')
            
            // Start connection health monitoring
            this.startConnectionHealthCheck()
        },

        onAdminDisconnect() {
            console.log('onAdminDisconnect called - admin disconnected')
            this.isConnectedToAdmin = false
            this.connectionStatus = 'Disconnected'
            console.log('Disconnected from admin')
            
            // Stop connection health monitoring
            this.stopConnectionHealthCheck()
            
            // Restart the connection process when disconnected
            if (this.character.should_connect) {
                console.log('Restarting connection process...')
                // Clear any existing connection check timer first
                if (this.connectionCheckTimer) {
                    clearInterval(this.connectionCheckTimer)
                    this.connectionCheckTimer = null
                }
                
                // Reset the private connector to ensure clean state
                if (this.privateConnector) {
                    this.privateConnector.disconnect()
                    this.privateConnector = null
                }
                
                // Reinitialize the connection process
                this.initializeAdminConnection()
            } else {
                console.log('Character should_connect is false, not restarting connection')
            }
        },

        sendMessageToAdmin(message) {
            if (this.privateConnector) {
                this.privateConnector.sendMessage(message)
            }
        },

        // Manual reconnection method for testing
        manualReconnect() {
            console.log('Manual reconnect triggered')
            this.isConnectedToAdmin = false
            this.connectionStatus = 'Disconnected'
            if (this.character.should_connect) {
                this.startAdminConnectionCheck()
            }
        },

        // Connection health monitoring
        startConnectionHealthCheck() {
            console.log('Starting connection health check')
            this.stopConnectionHealthCheck() // Clear any existing timer
            
            this.connectionHealthTimer = setInterval(() => {
                if (this.isConnectedToAdmin && this.privateConnector) {
                    // Check if the connection is still alive by trying to send a ping
                    try {
                        this.privateConnector.sendMessage({
                            type: 'ping',
                            timestamp: new Date().toISOString()
                        })
                    } catch (error) {
                        console.log('Connection health check failed, connection may be dead:', error)
                        // Force disconnect and restart
                        this.onAdminDisconnect()
                    }
                }
            }, 30000) // Check every 30 seconds
        },

        stopConnectionHealthCheck() {
            if (this.connectionHealthTimer) {
                clearInterval(this.connectionHealthTimer)
                this.connectionHealthTimer = null
                console.log('Stopped connection health check')
            }
        },

        openDiceSettings() {
            // Call the character sheet's openDiceSettings method
            if (this.$refs.characterSheet && this.$refs.characterSheet.openDiceSettings) {
                this.$refs.characterSheet.openDiceSettings();
            }
        },

        getAbilityShortName(ability) {
            const names = {
                strength: 'Str',
                dexterity: 'Dex',
                constitution: 'Con',
                intelligence: 'Int',
                wisdom: 'Wis',
                charisma: 'Cha'
            };
            return names[ability] || ability;
        },

        formatAbilityModifier(modifier) {
            return modifier >= 0 ? `+${modifier}` : `${modifier}`;
        },

        describeBuffEffect(effect) {
            return buffUtilities.describeEffect(
                effect,
                this.character.characterData,
                this.pointTrackers
            );
        },

        formatBuffDuration(rounds) {
            return buffUtilities.formatDuration(rounds);
        },

        // Adjust every active timed buff and common status; expired ones deactivate.
        advanceBuffTime(rounds) {
            (this.character.characterData.buffs || []).forEach(buff => {
                if (!buff.active || buff.remainingRounds == null) return;
                buff.remainingRounds = Math.max(0, buff.remainingRounds - rounds);
                if (buff.remainingRounds === 0) buff.active = false;
            });
            Object.values(this.character.characterData.commonStatuses || {}).forEach(state => {
                if (!state || !state.active || state.remainingRounds == null) return;
                state.remainingRounds = Math.max(0, state.remainingRounds - rounds);
                if (state.remainingRounds === 0) state.active = false;
            });
        },

        // Read-only lookup safe to call from the template (no mutation).
        getStatusState(statusId) {
            const states = this.character.characterData.commonStatuses;
            return (states && states[statusId]) || { active: false, remainingRounds: null };
        },

        // Creates the persisted state entry when missing (old saves).
        ensureStatusState(statusId) {
            const characterData = this.character.characterData;
            if (!characterData.commonStatuses) this.$set(characterData, 'commonStatuses', {});
            if (!characterData.commonStatuses[statusId]) {
                this.$set(characterData.commonStatuses, statusId, { active: false, remainingRounds: null });
            }
            return characterData.commonStatuses[statusId];
        },

        // Checking a status always (re)starts the shared duration, when one
        // is entered.
        onStatusToggled(status, active) {
            const state = this.ensureStatusState(status.id);
            state.active = !!active;
            if (!state.active) return;
            const duration = this.character.characterData.commonStatusDuration || {};
            const durationRounds = buffUtilities.getDurationRounds({ durationValue: duration.value, durationUnit: duration.unit });
            // Zero, negative, "-", blank, and other non-positive values mean
            // the status lasts indefinitely.
            state.remainingRounds = durationRounds == null ? null : durationRounds;
        },

        // The menu stores an id rather than the object: autosave replaces
        // characterData with a clone, which would orphan a held reference.
        openBuffTimeMenu(event, target) {
            this.buffTimeMenu.show = false;
            this.buffTimeMenu.x = event.clientX;
            this.buffTimeMenu.y = event.clientY;
            this.buffTimeMenu.target = target;
            this.$nextTick(() => {
                this.buffTimeMenu.show = true;
            });
        },

        resolveBuffTimeTarget(target) {
            if (!target) return null;
            if (target.kind === 'status') return this.ensureStatusState(target.id);
            return (this.character.characterData.buffs || []).find(buff => buff && buff.id === target.id) || null;
        },

        adjustBuffTime(rounds) {
            const buff = this.resolveBuffTimeTarget(this.buffTimeMenu.target);
            if (!buff) return;
            const current = buff.remainingRounds == null ? 0 : buff.remainingRounds;
            this.$set(buff, 'remainingRounds', Math.max(0, current + rounds));
            if (buff.remainingRounds === 0 && buff.active) buff.active = false;
        },

        // Activating a new or expired timed buff starts its full duration.
        onBuffToggled(buff) {
            if (!buff.active) return;
            const durationRounds = buffUtilities.getDurationRounds(buff);
            // An unset/non-positive duration represents an infinite buff.
            this.$set(buff, 'remainingRounds', durationRounds == null ? null : durationRounds);
        },
    },
    beforeDestroy() {
        this.isDestroyed = true
        this.loadGeneration += 1
        window.removeEventListener('message', this.handleRoll20Result);
        Object.values(this.pendingRoll20Requests).forEach(timeout => {
            window.clearTimeout(timeout);
        });
        this.pendingRoll20Requests = {};
        // Clean up timers
        if (this.connectionCheckTimer) {
            clearInterval(this.connectionCheckTimer)
        }
        if (this.connectionHealthTimer) {
            clearInterval(this.connectionHealthTimer)
        }
        if (this.privateConnector) {
            this.privateConnector.disconnect()
        }
        if (this.autoSaveTimeout) clearTimeout(this.autoSaveTimeout)
        this.stopCharacterSubscription()
        
        // Remove keyboard event listener
        window.removeEventListener('keydown', this.handleKeyboardShortcuts);
        
        // Clean up resize observer
        this.cleanupNotesResizeObserver();
    },
    watch:{
        'character.maneuverTracker': {
            handler: function() {
                this.markCharacterSectionChanged('maneuver_tracker')
            },
            deep: true
        },
        'character.characterData': {
            handler: function() {
                this.syncCalculatedDefenseTotals()
                this.markCharacterSectionChanged('character_data')
            },
            deep: true
        },
        'character.stickyWindows': {
            handler: function() {
                this.markCharacterSectionChanged('sticky_windows')
            },
            deep: true
        },
        'character.spellTracker': {
            handler: function() {
                this.markCharacterSectionChanged('spell_tracker')
            },
            deep: true
        },
        'character.psyche': {
            handler: function() {
                this.markCharacterSectionChanged('psyche')
            },
            deep: true
        },
        'character.characterName': function() {
            if (!this.isApplyingServerState) this.scheduleAutoSave()
        },
        characterLocked: function() {
            if (!this.isApplyingServerState) this.scheduleAutoSave()
        },
        autoSavingToServer: function(enabled) {
            if (enabled) this.scheduleAutoSave()
            else if (this.autoSaveTimeout) {
                clearTimeout(this.autoSaveTimeout)
                this.autoSaveTimeout = null
            }
        },
        autoUpdateFromServer: async function(enabled) {
            if (!enabled) {
                await this.stopCharacterSubscription()
                return
            }
            if (!this.uuid) return
            try {
                await this.subscribeToCharacter(this.uuid)
                await this.fetchCharacterRow(this.uuid)
            } catch (error) {
                console.error('Error enabling character Realtime updates:', error)
                this.scheduleRealtimeReconnect()
            }
        },
        'character.characterData.defense.ac.otherModifiers': {
            handler: function(newVal) {
                // Sync the character sheet's otherModifiers to quick details
                this.quickDetailsData.acModifiers = newVal;
            },
            deep: true
        },
        stickyNotes: {
            handler(newVal) {
                if (newVal) {
                    // Notes are being shown, set up observer after DOM update
                    this.$nextTick(() => {
                        this.setupNotesResizeObserver();
                    });
                } else {
                    // Notes are being hidden, clean up observer
                    this.cleanupNotesResizeObserver();
                }
            }
        },
    }
}
</script>
